module.exports = {
  QuickSearchAdNumber: 'Tìm kiếm nhanh: Mã quảng cáo',
  Remove: 'Gỡ xuống',
  Publish: 'Xuất bản',
  AdNumber: 'Mã quảng cáo',
  SubjectName: 'Chủ đề/Tên',
  AdContent: 'Nội dung quảng cáo',
  Advertiser: 'Chủ thể quảng cáo',
  AdPosition: 'Vị trí quảng cáo',
  BelongToPage: 'Trang thuộc về',
  BelongToModule: 'Mô-đun thuộc về',
  BelongToSystem: 'Hệ thống thuộc về',
  Status: 'Trạng thái',
  TargetAudience: 'Đối tượng hiển thị',
  Global: 'Toàn cục',
  Creator: 'Người tạo',
  CreationDate: 'Ngày tạo',
  Modifier: 'Người sửa',
  ModificationDate: 'Ngày sửa',
  PromotionPeriod: 'Chu kỳ quảng bá',
  EffectiveTime: 'Thời gian hiệu lực',
  ExpirationTime: 'Thời gian hết hạn',
  PleaseCheckOneEntry: 'Vui lòng chọn một dữ liệu!',
  ContainsUnremovedData: 'Bao gồm dữ liệu chưa gỡ xuống!',
  AreYouWantToDelete: 'Xác nhận xóa?',
  PleaseSelectOneEntry: 'Vui lòng chọn một dữ liệu!',
  PleaseOnlySelectOneRecord: 'Vui lòng chỉ chọn một bản ghi!',
  ContainsAlreadyRemovedData: 'Bao gồm dữ liệu đã gỡ xuống!',
  AreYouWantToRemove: 'Xác nhận gỡ xuống?',
  AreYouWantToPublish: 'Xác nhận xuất bản?',
  ThePositionHasBeenDisabled: 'Vị trí quảng cáo này đã ngừng hoạt động!',
  TheReachedTheMaximumPlacements: 'Vị trí quảng cáo này đã đạt số lượng hiển thị tối đa!',
  RemainingAreNotEnoughCheck: 'Không đủ vị trí quảng cáo còn lại, vui lòng kiểm tra!',
  ContainsPublishedOrExpiredData: 'Bao gồm dữ liệu đã xuất bản hoặc hết hạn!',
  View: 'Xem',
  Edit: 'Chỉnh sửa',
  Enable: 'Kích hoạt',
  Disable: 'Ngừng hoạt động',
  AdPositionNumber: 'Mã vị trí quảng cáo',
  CurrentlyPlacedAdCount: 'Số quảng cáo đã hiển thị',
  MaximumSupportedAdCount: 'Số quảng cáo tối đa hỗ trợ',
  CurrentDisabledAndCannotEdited: 'Dữ liệu hiện tại chưa ngừng hoạt động, không thể chỉnh sửa!',
  AreYouWantToDisable: 'Xác nhận ngừng hoạt động?',
  AreYouWantToDisable2: 'Xác nhận ngừng hoạt động?',
  ContainsNonDisabledData: 'Bao gồm dữ liệu chưa ngừng hoạt động!',
  AreYouWantToEnable: 'Xác nhận kích hoạt?',
  TemplateManagement: 'Quản lý mẫu',
  TemplateTypeManagement: 'Quản lý loại mẫu',
  ConfigurationManagement: 'Quản lý cấu hình',
  MappingManagement: 'Quản lý ánh xạ',
  InitializeTemplateManagement: 'Quản lý mẫu khởi tạo',
  BusinessStatusManagement: 'Quản lý trạng thái nghiệp vụ',
  TriggerTypeManagement: 'Quản lý loại kích hoạt',
  FileTypeManagement: 'Quản lý loại tệp',
  DefaultValueManagement: 'Quản lý giá trị mặc định',
  ValidationRuleConfiguration: 'Cấu hình quy tắc xác thực',
  EDITemplateSetting: 'Thiết lập mẫu EDI',
  SeaFreightOnlineCheckingSettings: 'Thiết lập đối chiếu đơn hàng trực tuyến vận tải biển',
  ShippingRouteAndWarehouseConfiguration: 'Cấu hình tuyến đường và kho hàng',
  PushServiceConfiguration: 'Cấu hình dịch vụ đẩy',
  InvoiceCustomRemark: 'Ghi chú tùy chỉnh hóa đơn',
  CustomRemarkOne: 'Ghi chú tùy chỉnh 1',
  CustomRemarkTwo: 'Ghi chú tùy chỉnh 2',
  EmailTemplateManagement: 'Quản lý mẫu hộp thư',
  ReleaseConfiguration: 'Cấu hình phát hành đơn',
  PromotionTimeRange: 'Khung giờ quảng cáo',
  JumpLink: 'Liên kết chuyển hướng',
  Cancel: 'Hủy',
  Save: 'Lưu',
  Return: 'Quay lại',
  Homepage: 'Trang chủ',
  SelectAll: 'Chọn tất cả',
  DeselectAll: 'Bỏ chọn tất cả',
  AreYouWantToCancel: 'Xác nhận hủy?',
  NumberOfClickedUsers: 'Số lượt nhấp người dùng',
  BelongToCompany: 'Công ty sở hữu',
  UserType: 'Loại người dùng',
  Username: 'Tên người dùng',
  PlatformCustomerService: 'Hỗ trợ khách hàng nền tảng',
  ClickTime: 'Thời gian nhấp',
  BrowsingTime: 'Thời gian duyệt',
  StartTime: 'Thời gian bắt đầu:',
  EndTime: 'Thời gian kết thúc:',
  SequenceNumber: 'Số thứ tự',
  Code: 'Mã',
  ChineseName: 'Tên tiếng Trung',
  EnglishName: 'Tên tiếng Anh',
  NodeType: 'Loại nút',
  Remarks: 'Ghi chú',
  CreateStatus: 'Trạng thái mới',
  Delete: 'Xóa',
  IsItPublic: 'Có công khai không',
  CreateStatusDetail: 'Chi tiết trạng thái mới',
  EditStatus: 'Chỉnh sửa trạng thái',
  DeleteSuccessful: 'Xóa thành công',
  SaveSuccessful: 'Lưu thành công',
  PleaseEnterCode: 'Vui lòng nhập mã',
  PleaseEnterNodeType: 'Vui lòng nhập loại nút',
  PleaseEnterCodeChineseName: 'Vui lòng nhập tên tiếng Trung của mã',
  PleaseEnterCodeEnglishName: 'Vui lòng nhập tên tiếng Anh của mã',
  StatusType: 'Loại trạng thái',
  ExternalCode: 'Mã bên ngoài',
  Name: 'Tên',
  GenerateElectronicFile: 'Tạo tệp điện tử',
  FileType: 'Loại tệp',
  DataService: 'Dịch vụ dữ liệu',
  ReportTemplate: 'Mẫu báo cáo',
  PushObject: 'Đối tượng nhận',
  PushChannel: 'Kênh gửi',
  SubjectTemplate: 'Mẫu chủ đề',
  BodyTemplate: 'Mẫu nội dung',
  DataItem: 'Mục dữ liệu',
  AttachmentFileType: 'Loại tệp đính kèm',
  TemplateSubject: 'Chủ đề mẫu',
  TemplateContent: 'Nội dung mẫu',
  TemplateExample: 'Ví dụ mẫu',
  SendTest: 'Gửi thử nghiệm',
  ConfigureSOPMessagePush: 'Cấu hình gửi tin nhắn SOP',
  EditStatusDetail: 'Chỉnh sửa chi tiết trạng thái',
  InitialStatus: 'Trạng thái ban đầu',
  AutoTrigger: 'Tự động kích hoạt',
  StatusChangeNotification: 'Thông báo thay đổi trạng thái',
  SendNotification: 'Gửi thông báo',
  NoNotification: 'Không gửi thông báo',
  DesignatedPosition: 'Vị trí chỉ định',
  Sales: 'Kinh doanh',
  Operation: 'Thao tác',
  CustomerService: 'Dịch vụ khách hàng',
  OverseasCustomerService: 'Dịch vụ khách hàng hải ngoại',
  Documentation: 'Chứng từ',
  ShippingLineManager: 'Người phụ trách tuyến',
  DesignatedPersonnel: 'Nhân viên chỉ định',
  Email: 'Email',
  SopPushLog: 'Nhật ký gửi SOP',
  Confirm: 'Xác nhận',
  SendTo: 'Gửi đến:',
  Note: 'Lưu ý',
  WillBusinessDetailsAndNodes: 'Sẽ xóa các chi tiết nghiệp vụ và nút SOP liên quan',
  PleaseEnterContent: 'Vui lòng nhập nội dung',
  NotStarted: 'Chưa bắt đầu',
  InProgress: 'Đang tiến hành',
  Completed: 'Đã hoàn thành',
  Abnormal: 'Bất thường',
  BookingSuccessful: 'Đặt chỗ thành công',
  WarehouseEntryNotice: 'Thông báo nhập kho',
  CustomsClearance: 'Thông quan',
  SailingNotice: 'Thông báo khởi hành',
  IssuanceOfBillOfLading: 'Phát hành vận đơn',
  Customer: 'Khách hàng',
  DestinationPortAgent: 'Đại lý cảng đến',
  DesignatedFreightForwarder: 'Đại lý hàng chỉ định',
  DeparturePortAgent: 'Đại lý cảng đi',
  DesignatedPositionsAndPersonnel: 'Vị trí chỉ định và nhân viên chỉ định',
  PleaseEnterTheCode: 'Vui lòng nhập mã',
  PleaseEnterTheChineseName: 'Vui lòng nhập tên tiếng Trung',
  ChineseNameLengthExceeded20: 'Tên tiếng Trung vượt quá 20 ký tự!',
  PleaseEnterTheEnglishName: 'Vui lòng nhập tên tiếng Anh',
  PleaseSelectTheStatusType: 'Vui lòng chọn loại trạng thái!',
  PleaseSelectTheTriggerType: 'Vui lòng chọn loại kích hoạt',
  PleaseSelectTheStatusType2: 'Vui lòng chọn loại trạng thái',
  TheAlreadyExistsPleaseEnter: 'Mã đã tồn tại, vui lòng nhập lại!',
  TheAlreadyExistsPleaseEnter2: 'Tên tiếng Trung đã tồn tại, vui lòng nhập lại!',
  TheAlreadyExistsPleaseEnter3: 'Tên tiếng Anh đã tồn tại, vui lòng nhập lại!',
  SaveSuccess: 'Lưu thành công',
  DeleteSuccess: 'Xóa thành công',
  BusinessDetailsDoNotExist: 'Chi tiết nghiệp vụ không tồn tại',
  PleaseEnterTheSubjectTemplate: 'Vui lòng nhập mẫu chủ đề',
  PleaseTheTextTemplateContent: 'Vui lòng nhập nội dung mẫu văn bản',
  PleaseEnterTheTemplateContent: 'Vui lòng nhập nội dung mẫu',
  PleaseEnterTheTemplateExample: 'Vui lòng nhập ví dụ mẫu',
  PleaseFirstSelectData: 'Vui lòng chọn dữ liệu trước',
  AreWantToDeleteRecord: 'Xác nhận xóa bản ghi đã chọn?',
  Tips: 'Thông báo',
  PleaseTheTestEmailAddress: 'Vui lòng nhập địa chỉ email kiểm tra!',
  EmailFormatError: 'Định dạng email sai!',
  EmailCannotExceed128Characters: 'Email không được vượt quá 128 ký tự',
  PleaseTestMobilePhoneNumber: 'Vui lòng nhập số điện thoại kiểm tra!',
  MobileCanOnlyBeNumbers: 'Số điện thoại chỉ được chứa chữ số hợp lệ!',
  MobilePhoneNumberFormatError: 'Định dạng số điện thoại sai!',
  SendSuccess: 'Gửi thành công!',
  SendFailure: 'Gửi thất bại!',
  APIOutputAdditionalInformation: 'Thông tin bổ sung đầu ra API',
  OutputDescription: 'Giải thích đầu ra',
  OutputIdentification: 'Định danh đầu ra',
  DataSource: 'Nguồn dữ liệu',
  DataField: 'Trường dữ liệu',
  WarningSwitch: 'Công tắc cảnh báo',
  SailingTimeETD: 'Thời gian khởi hành (ETD)',
  ArrivalTimeETA: 'Thời gian đến cảng (ETA)',
  OpenPortTime: 'Thời gian mở cảng',
  ClosingPortTime: 'Thời gian đóng cảng',
  ClosingTimeForOrders: 'Thời gian đóng đơn',
  CustomsClosingTime: 'Thời gian đóng hải quan',
  ScheduledBerthingDate: 'Ngày dự kiến cập cảng',
  ScheduledDepartureDate: 'Ngày dự kiến rời cảng',
  WarningTime: 'Thời gian cảnh báo',
  Advance: 'Sớm hơn',
  Delay: 'Muộn hơn',
  WarningSettings: 'Cài đặt cảnh báo',
  TurnOnWarning: 'Bật cảnh báo',
  TurnOffWarning: 'Tắt cảnh báo',
  HoursWarningReminder: 'Giờ, nhắc nhở cảnh báo',
  Highest: 'Cao nhất',
  High: 'Cao',
  Medium: 'Trung bình',
  Low: 'Thấp',
  Relation: 'Quan hệ',
  FilterValue: 'Giá trị lọc',
  ValidationCondition: 'Điều kiện kiểm tra',
  New: 'Tạo mới',
  And: 'Và',
  Or: 'Hoặc',
  FilterBasis: 'Căn cứ lọc',
  CurrentlyModeUnableToNew: 'Hiện đang trong trạng thái chỉnh sửa, không thể tạo mới',
  CurrentlyModeUnableToDelete: 'Hiện đang trong trạng thái chỉnh sửa, không thể xóa',
  PleaseSelectAFilterBasis: 'Vui lòng chọn căn cứ lọc',
  PleaseSelectTheFilterValue: 'Vui lòng chọn giá trị lọc',
  ValidationExpression: 'Biểu thức kiểm tra',
  PositiveOperation: 'Thao tác chính',
  PreSubmit: 'Gửi trước',
  Submitted: 'Đã gửi',
  Reviewed: 'Đã duyệt',
  ValidationItem: 'Hạng mục kiểm tra',
  Empty: 'Trống',
  PleaseSelectValidationItem: 'Vui lòng chọn hạng mục kiểm tra',
  RuleName: 'T/quy tắc',
  ValidationNode: 'Nút kiểm tra',
  ValidationType: 'Loại kiểm tra',
  ValidationMode: 'Chế độ kiểm tra',
  EmailAddress: 'Địa chỉ email',
  Add: 'Thêm mới',
  Refresh: 'Làm mới',
  ValidationRules: 'Quy tắc kiểm tra',
  AllowOperationAfterValidationFails: 'Sau khi kiểm tra không đạt, có cho phép tiếp tục thao tác không?',
  Yes: 'Có',
  No: 'Không',
  Company: 'Công ty',
  ContinueValidation: 'Tiếp tục kiểm tra',
  CurrentlyYouSureYouRefresh: 'Hiện đang trong trạng thái chỉnh sửa, xác nhận làm mới?',
  FailedToInitializeData: 'Khởi tạo dữ liệu thất bại',
  AreRuleAssociatedValidationDeleted: 'Xác nhận xóa quy tắc kiểm tra này? Biểu thức kiểm tra và điều kiện kiểm tra liên quan cũng sẽ bị xóa!',
  PleaseSelectTheBranchOffice: 'Vui lòng chọn chi nhánh',
  PleaseEnterTheRuleName: 'Vui lòng nhập tên quy tắc',
  PleaseSelectTheRuleNode: 'Vui lòng chọn nút quy tắc',
  PleaseSelectTheRuleType: 'Vui lòng chọn loại quy tắc',
  PleaseSelectTheRuleMode: 'Vui lòng chọn chế độ quy tắc',
  CompanyName: 'Tên công ty',
  PleaseConfigurationNameOrRemarks: 'Vui lòng nhập tên cấu hình hoặc ghi chú',
  Type: 'Loại',
  InterfaceSettings: 'Thiết lập giao diện',
  ConfigurationName: 'Tên cấu hình',
  DefaultValue: 'Giá trị mặc định',
  EditConfigurationItem: 'Chỉnh sửa mục cấu hình',
  EditConfigurationDefinition: 'Chỉnh sửa định nghĩa cấu hình:',
  Search: 'Tìm kiếm',
  ConfigurationItemconfigId: 'Mục cấu hình (configId)',
  TypedataType: 'Loại dữ liệu (dataType)',
  InterfaceSettingsisClient: 'Cài đặt giao diện (isClient)',
  BranchOfficeOptionisOfficeOption: 'Tùy chọn chi nhánh (isOfficeOption)',
  ServiceSettingsisServer: 'Cài đặt dịch vụ (isServer)',
  OptionalItemliterals: 'Tùy chọn (literals)',
  ConfigurationNamename: 'Tên cấu hình (name)',
  Remarksremarks: 'Ghi chú (remarks)',
  DefaultValuevalue: 'Giá trị mặc định (value)',
  ConfigurationNameCannotBeEmpty: 'Tên cấu hình không được để trống',
  DefaultValueCannotBeEmpty: 'Giá trị mặc định không được để trống',
  PleaseEnterTheBranchOffice: 'Vui lòng nhập chi nhánh',
  Value: 'Giá trị',
  ConfigurationItem: 'Mục cấu hình',
  BranchOffice: 'Chi nhánh',
  PleaseSelectAConfigurationDefinition: 'Vui lòng chọn một định nghĩa cấu hình',
  BranchOfficeCannotBeEmpty: 'Chi nhánh không được để trống!',
  ValueCannotBeEmpty: 'Giá trị không được để trống!',
  TheConfigurationAlreadyExistsCheck: 'Đã tồn tại cấu hình chi nhánh trùng lặp, vui lòng kiểm tra',
  ApplyHeadOfficeSettings: 'Áp dụng cài đặt trụ sở chính',
  SleepingDays: 'Số ngày không hoạt động',
  SigningDays: 'Số ngày ký đơn',
  NotificationObject: 'Đối tượng thông báo:',
  Supervisor: 'Quản lý cấp trên',
  NotificationMethod: 'Phương thức thông báo:',
  InternalReminder: 'Nhắc nhở nội bộ',
  HowDaysBeforeExpirationNotice: 'Thông báo trước bao nhiêu ngày khi đến hạn:',
  Days: 'ngày',
  DayMaintenance: 'Bảo trì số ngày:',
  BusinessEntity: 'Thực thể nghiệp vụ',
  SelectEntityConfigurationItem: 'Chọn mục cấu hình thực thể',
  BranchOffice2: 'Chi nhánh:',
  EntitySelection: 'Lựa chọn thực thể:',
  AffiliatedBranchOffice: 'Chi nhánh trực thuộc',
  EntityCode: 'Mã thực thể',
  EntityName: 'Tên thực thể',
  FieldCode: 'Mã trường',
  FieldName: 'Tên trường',
  ValueType: 'Loại giá trị',
  All: 'Tất cả',
  SelectBranch: 'Chọn chi nhánh',
  Unused: 'Chưa sử dụng',
  Used: 'Đã sử dụng',
  Example8180ThisTicketOnlyDollars: 'Ví dụ: USD:355/Tỷ giá:6.8180/Chỉ thu USD cho hóa đơn này',
  Precautions: 'Lưu ý:',
  SavedEffectFromTheInvoice: 'Cấu hình sẽ có hiệu lực từ hóa đơn tiếp theo sau khi lưu',
  EBeLessThanCharacters: 'Ghi chú hóa đơn điện tử phải ít hơn 100 ký tự',
  PaperBeLessThanCharacters: 'Ghi chú trên vé giấy phải ít hơn 200 chữ',
  AutomaticallyALineDoesShow: 'Tự động xuống dòng khi không hiển thị hết trong một dòng',
  PDFCanDisplayUpLines: 'Phần ghi chú trên hóa đơn PDF chỉ hiển thị tối đa 3 dòng',
  SerialNumber: 'Số thứ tự',
  ExternalFileType: 'Loại tài liệu bên ngoài',
  NecessaryScenario: 'Tình huống bắt buộc',
  OriginalScenario: 'Tình huống bản gốc',
  TypePermission: 'Quyền theo loại',
  AllPositions: 'Tất cả vị trí',
  Client: 'Đơn vị ủy thác',
  Shipper: 'Người gửi hàng',
  Consignee: 'Người nhận hàng',
  OverseasAgent: 'Đại lý nước ngoài',
  BookingAgent: 'Đại lý đặt chỗ',
  PleaseSelectBookingAgent: 'Vui lòng chọn đại lý đặt chỗ',
  ExternalAccess: 'Truy cập bên ngoài',
  B2BCustomer: 'Khách hàng B2B',
  B2BDesignatedCargoAgent: 'Đại lý hàng hóa chỉ định B2B',
  B2BDestinationPortAgent: 'Đại lý cảng đích B2B',
  B2BConsignee: 'Người nhận hàng B2B',
  TemplateOutputName: 'Tên xuất mẫu',
  Delimiter: 'Dấu phân cách',
  NoteTemplateNameAccordingNeeds: 'Lưu ý: Vui lòng tự định nghĩa tên mẫu xuất theo nhu cầu',
  DefaultSync: 'Đồng bộ mặc định',
  UsedFileAutomaticallySynchronizesBusiness: 'Dùng để thiết lập loại tài liệu này có tự động đồng bộ giữa nghiệp vụ xuất và nhập khẩu hay không',
  CustomTemplateName: 'Tên mẫu tùy chỉnh',
  TemplateName: 'Tên mẫu',
  Underscore_: 'Dấu gạch dưới _',
  Hyphen: 'Dấu gạch ngang -',
  CreateFileClassification: 'Phân loại tài liệu mới',
  CreateFileType: 'Loại tài liệu mới',
  Create: 'Tạo mới',
  Modify: 'Chỉnh sửa',
  FileClassification: 'Phân loại tài liệu',
  CurrentOperationStatusIsAbnormal: 'Trạng thái thao tác hiện tại bất thường!',
  PleaseSelectChineseName: 'Vui lòng chọn tên tiếng Trung',
  CurrentOperatingStatusAbnormal: 'Trạng thái thao tác hiện tại bất thường',
  CondAlreadyExists: 'Cond đã tồn tại',
  EDIFileDefaultTypeDefaultFileType: 'Loại mặc định tệp EDI (DefaultFileType)',
  Emailemail: 'Hộp thư (email)',
  EDIFileEncodingTypeEncodingType: 'Loại mã hóa tệp EDI (EncodingType)',
  EDIFileCombinationMethodFileCombineType: 'Phương thức hợp nhất tệp EDI (FileCombineType)',
  PartnerCodeParnterId: 'Mã đối tác (PartnerId)',
  SendFTPFileNamePrefixsendFilePrefix: 'Tiền tố tên tệp FTP gửi đi (sendFilePrefix)',
  SendFTPAddressTypesendType: 'Loại địa chỉ FTP gửi đi (sendType)',
  ServiceTypeServiceType: 'Loại dịch vụ (ServiceType)',
  TemplateDescriptionTemplateDescribe: 'Mô tả mẫu (TemplateDescribe)',
  TemplateAccessPathTemplatePath: 'Đường dẫn truy cập mẫu (TemplatePath)',
  TemplateTypeTemplateType: 'Loại mẫu (TemplateType)',
  ShutNoticeShutOutIdentification: 'Thông báo hủy thông quan (Shut-out identification)',
  BootHelperPage: 'Trang hỗ trợ khởi động (Boot helper page)',
  EDITemplateMaintenance: 'Bảo trì mẫu EDI',
  PleaseEDIFileCombinationMethod: 'Vui lòng nhập phương thức hợp nhất tệp EDI',
  EDIMethodMustBeType: 'Phương thức hợp nhất tệp EDI phải là kiểu số',
  PleaseEnterPartnerCode: 'Vui lòng nhập mã đối tác',
  PartnerMustBeNumericType: 'Mã đối tác phải là kiểu số',
  PleaseEnterServiceType: 'Vui lòng nhập loại dịch vụ',
  ServiceMustBeNumericType: 'Loại dịch vụ phải là kiểu số',
  PleaseEnterTemplateDescription: 'Vui lòng nhập mô tả mẫu',
  PleaseEnterTemplateAccessPath: 'Vui lòng nhập đường dẫn truy cập mẫu',
  PleaseEnterTemplateType: 'Vui lòng nhập loại mẫu',
  TemplateMustBeNumericType: 'Loại mẫu phải là kiểu số',
  ShutMustBeNumericType: 'Báo hủy quan phải là kiểu số',
  CloudStorageID: 'ID lưu trữ đám mây',
  TemplateFileCloudStorage: 'Lưu trữ đám mây tệp mẫu',
  PleaseTemplateYouWantEdit: 'Vui lòng chọn mẫu cần chỉnh sửa!',
  PleaseTemplateYouWantDelete: 'Vui lòng chọn mẫu cần xóa!',
  ConfirmDeletionOfThisTemplate: 'Xác nhận xóa mẫu này?',
  TemplateDeletedSuccessfully: 'Xóa mẫu thành công!',
  TemplateDeletionFailed: 'Xóa mẫu thất bại!',
  BasicFailedPleaseTryAgain: 'Cập nhật mẫu cơ bản thất bại, vui lòng thử lại!',
  BasicTemplateUpdateSuccessful: 'Cập nhật mẫu cơ bản thành công!',
  PleaseEnterKeywordsToSearch: 'Vui lòng nhập từ khóa tìm kiếm',
  EmailTemplateEditing: 'Chỉnh sửa mẫu hộp thư',
  PushingLink: 'Giai đoạn đẩy thông báo',
  TextTemplate: 'Mẫu nội dung',
  Reminder: 'Thông báo',
  SendEmail: 'Gửi email:',
  OK: 'Xác nhận',
  BasicData: 'Dữ liệu cơ bản',
  SystemEmail: 'Hộp thư hệ thống',
  PicturePictureMustNot10M: 'Tải lên hình ảnh thất bại, kích thước tối đa không vượt quá 10M!',
  PleaseAddProductDescriptionHere: 'Vui lòng thêm mô tả sản phẩm tại đây',
  PreSendingSupplementaryInvitationLink: 'Gửi liên kết mời bổ sung thông tin cấu hình',
  MarineMBLInvitationForProofreading: 'MBL xuất khẩu đường biển mời đối chiếu',
  MarineHBLInvitationForProofreading: 'HBL xuất khẩu đường biển mời đối chiếu',
  MarineExportBulkPrinting: 'In hàng loạt xuất khẩu đường biển',
  AirCargoStorage: 'Kho hàng không',
  BillOfLadingPrintProduction: 'Làm và in vận đơn',
  FileHistory: 'Lịch sử tệp',
  InvoicePush: 'Đẩy hóa đơn',
  OceanShippingAlertReminderEmail: 'Email cảnh báo - Vận tải biển',
  ReminderEmail: 'Email nhắc nhở',
  AirExportAlertReminderEmail: 'Email cảnh báo - Xuất khẩu hàng không',
  RailwayAlertReminderEmail: 'Email cảnh báo - Đường sắt',
  AirImportAlertReminderEmails: 'Email cảnh báo - Nhập khẩu hàng không',
  IntegratedAlertReminderEmails: 'Email cảnh báo - Logistics tổng hợp',
  BookingPageData: 'Dữ liệu trang đặt chỗ',
  ContentTemplate: 'Mẫu nội dung',
  Updater: 'Người cập nhật',
  LastUpdateTime: 'Thời gian cập nhật cuối cùng',
  UploadedBeLargerThan20MB: 'Ảnh tải lên không được lớn hơn 20MB',
  PictureInsertionFailed: 'Chèn ảnh thất bại',
  OnlyVieweditOneEmailTemplate: 'Chỉ được phép xem/chỉnh sửa một mẫu email',
  CompanyEmail: 'Email công ty',
  PersonalEmail: 'Email cá nhân',
  SentSuccessfully: 'Gửi thành công!',
  ConfirmTheModifiedContent: 'Xác nhận nội dung đã chỉnh sửa?',
  ConfirmCancelingTheFilledmodifiedContent: 'Xác nhận hủy nội dung đã điền/chỉnh sửa?',
  PleaseInTheRecipientsEmail: 'Vui lòng điền email người nhận!',
  MappingType: 'Loại ánh xạ',
  Description: 'Mô tả',
  Condition: 'Điều kiện',
  SendingPlatform: 'Nền tảng gửi',
  EnglishName2: 'Tên tiếng Anh',
  ChineseName2: 'Tên tiếng Trung',
  OriginalValue: 'Giá trị gốc',
  NewValue: 'Giá trị mới',
  EditMapping: 'Chỉnh sửa ánh xạ',
  CreateMapping: 'Tạo ánh xạ mới',
  PleaseEnterMappingType: 'Nhập loại ánh xạ',
  PleaseEnterTheOriginalValue: 'Nhập giá trị gốc',
  PleaseEnterTheNewValue: 'Nhập giá trị mới',
  Branch: 'Chi nhánh',
  EnableAutomaticPush: 'Bật tự động đẩy',
  SOPPushChannel: 'Kênh đẩy SOP:',
  PushOnlyAfterConfirmingRecipient: 'Chỉ đẩy trạng thái SOP sau khi xác nhận người nhận SOP:',
  PleaseSendersEmailWhichEmails: 'Vui lòng chọn các email dưới đây làm email gửi và có thể sử dụng khi gửi email.',
  Username2: 'Tên người dùng:',
  EmailPasswordauthorizationCode: 'Mật khẩu email/mã ủy quyền:',
  EmailDisplayName: 'Tên hiển thị email:',
  SenderServer: 'Máy chủ gửi:',
  Port: 'Cổng:',
  WhenActualSenderIsEmail: 'Khi chọn email cá nhân, người gửi thực tế là email đăng ký của mỗi người dùng.',
  CompanyEnglishAbbreviation: 'Tên viết tắt tiếng Anh công ty:',
  BasicConfiguration: 'Cấu hình cơ bản',
  SMS: 'SMS',
  Open: 'Bật',
  Close: 'Tắt',
  EmailConfiguration: 'Cấu hình email',
  Signature: 'Chữ ký:',
  EnableSignature: 'Bật chữ ký',
  SMSConfiguration: 'Cấu hình SMS',
  PleaseAProductDescriptionHere: 'Vui lòng thêm mô tả sản phẩm tại đây',
  CompanyAbbreviationCannotBeEmpty: 'Tên viết tắt tiếng Trung công ty không được để trống!',
  CompanyUsernameCannotBeEmpty: 'Tên người dùng email công ty không được để trống!',
  CompanyCodeCannotBeEmpty: 'Mật khẩu email/mã ủy quyền email công ty không được để trống!',
  CompanyServerCannotBeEmpty: 'Máy chủ gửi email công ty không được để trống!',
  CompanyNumberMustBeNumber: 'Số cổng email công ty phải là số!',
  PersonalUsernameCannotBeEmpty: 'Tên người dùng email cá nhân không được để trống!',
  PersonalServerCannotBeEmpty: 'Máy chủ gửi email cá nhân không được để trống!',
  PersonalNumberMustBeNumber: 'Cổng email cá nhân phải là số!',
  AdditionalOutputAssociatedTemplate: 'Mẫu liên kết đầu ra bổ sung',
  TemplateEngine: 'Công cụ mẫu',
  FilterScript: 'Kịch bản lọc',
  BranchSerialNumber: 'Số thứ tự chi nhánh',
  TemplateFile: 'Tệp mẫu',
  TemplateClass: 'Loại mẫu',
  TemplateUsage: 'Mục đích mẫu',
  Print: 'In',
  CreateTemplate: 'Tạo mẫu',
  TemplateFileCloudStorageID: 'ID lưu trữ đám mây tệp mẫu',
  TemplateSerialNumber: 'Số thứ tự mẫu',
  SchemaTypeNotMaintained: 'SchemaType chưa được bảo trì',
  CannotCheckWhetherTheCorrect: 'Không tìm thấy thông tin mẫu cơ bản, vui lòng kiểm tra nguồn dữ liệu mẫu có chính xác không!',
  SchemaTypeCannotBeEmpty: 'Schema Type không được để trống.',
  TemplateTypeCannotBeEmpty: 'Template Type không được để trống',
  TemplateDescCannotBeEmpty: 'Template Type Desc không được để trống',
  ChineseNameLengthExceeds20: 'Tên tiếng Trung vượt quá 20 ký tự!',
  PleaseSelectStatusType: 'Vui lòng chọn loại trạng thái!',
  PleaseSelectATriggerType: 'Vui lòng chọn loại kích hoạt',
  DropThisConditionForGoods: '*Hộp chọn thả xuống trống có nghĩa là không xem xét điều kiện này. Ví dụ: không xem xét loại hàng hóa',
  PushTarget: 'Đối tượng đẩy',
  BookingSuccess: 'Đặt chỗ thành công',
  WarehouseEntryNotification: 'Thông báo nhập kho',
  BillOfLadingIssuance: 'Phát hành vận đơn',
  DesignatedFreightAgent: 'Đại lý hàng hóa chỉ định',
  DesignatedPostAndDesignatedPersonnel: 'Vị trí chỉ định và nhân viên chỉ định',
  PleaseSelectDataFirst: 'Vui lòng chọn dữ liệu trước',
  AreToDeleteTheRecord: 'Xác nhận xóa bản ghi đã chọn?',
  Hint: 'Thông báo',
  PleaseEnterTestEmailAddress: 'Vui lòng nhập địa chỉ email thử nghiệm!',
  PleaseEnterTestMobileNumber: 'Vui lòng nhập số điện thoại thử nghiệm!',
  MobileOnlyBeANumber: 'Số điện thoại chỉ có thể là số hợp lệ!',
  MobileNumberFormatError: 'Định dạng số điện thoại sai!',
  SendingSuccessful: 'Gửi thành công!',
  SendingFailed: 'Gửi thất bại!',
  ChineseName3: 'Tên tiếng Trung',
  EnglishName3: 'Tên tiếng Anh',
  PublicOrNot: 'Có công khai không',
  Remark: 'Ghi chú',
  AutomaticTrigger: 'Tự động kích hoạt',
  DoNotSendNotification: 'Không gửi thông báo',
  DesignatedPost: 'Vị trí chỉ định',
  Documentary: 'Chứng từ',
  LineManager: 'Người phụ trách tuyến đường',
  PleaseEnterChineseName: 'Vui lòng nhập tên tiếng Trung',
  PleaseEnterEnglishName: 'Vui lòng nhập tên tiếng Anh',
  PleaseSelectTriggerType: 'Vui lòng chọn loại kích hoạt',
  PleaseSelectStatusType2: 'Vui lòng chọn loại trạng thái',
  ThereSameCodePleaseEnter: 'Đã tồn tại mã trùng lặp, vui lòng nhập lại!',
  ThereSameChineseNameEnter: 'Đã tồn tại tên tiếng Trung trùng lặp, vui lòng nhập lại!',
  ThereSameEnglishNameEnter: 'Đã tồn tại tên tiếng Anh trùng lặp, vui lòng nhập lại!',
  PleaseEnterFieldName: 'Vui lòng nhập tên trường',
  PleaseEnterFieldEnglishName: 'Vui lòng nhập tên tiếng Anh của trường',
  AreToDeleteTheType: 'Xác nhận xóa loại kích hoạt?',
  AllCharts: 'Tất cả biểu đồ',
  BusinessCharts: 'Biểu đồ nghiệp vụ',
  FinancialCharts: 'Biểu đồ tài chính',
  ControlMode: 'Chế độ kiểm soát:',
  ReceivingOrder: 'Tiếp nhận đơn',
  Printing: 'In',
  BillOfLadingRelease: 'Phát hành vận đơn',
  NoDeduction: 'Không giữ đơn',
  OnlyHBL: 'Chỉ có HBL',
  OnlyHBLDeductHBL: 'Chỉ giữ HBL khi có HBL',
  OnlyMBL: 'Chỉ có MBL',
  OnlyMBLDeductMBL: 'Chỉ giữ MBL khi có MBL',
  HBLAtTheSameTime: 'Có cả HBL và MBL',
  HBLAtTheSameTime2: 'Giữ đồng thời HBL và MBL',
  OnlyHBLWithoutDeductingMBL: 'Chỉ giữ HBL không giữ MBL',
  DoHBLOnlyDeductMBL: 'Không giữ HBL chỉ giữ MBL',
  DocumentCirculation: 'Luân chuyển chứng từ',
  ApplyTheHeadOfficesSettings: 'Áp dụng cài đặt trụ sở chính',
  ReminderMode: 'Chế độ nhắc nhở',
  LockingMode: 'Chế độ khóa đơn',
  WhenRemindersAndTheLocked: 'Khi vượt hạn mức tín dụng, chỉ gửi cảnh báo, không khóa phiếu làm việc',
  WhenOrderUntilItApproved: 'Khi vượt hạn mức tín dụng, khóa phiếu làm việc đến khi mở khóa tự động hoặc phê duyệt đặc biệt',
  NotificationReminder: 'Thông báo nhắc nhở:',
  LockingControl: 'Kiểm soát khóa:',
  Event: 'Sự kiện',
  IsLocked: 'Có khóa hay không',
  ControlObject: 'Đối tượng kiểm soát',
  ControlMethod: 'Phương thức kiểm soát',
  PrintTemplate: 'Mẫu in',
  Document: 'Chứng từ',
  EmailAndReminder: 'Email và nhắc nhở',
  None: 'Không có',
  SaveAndLock: 'Khóa sau khi lưu',
  CannotSave: 'Không thể lưu',
  BusinessLocked: 'Nghiệp vụ bị khóa',
  BusinessUnlocked: 'Nghiệp vụ được mở khóa',
  CreditControlExceed: 'Vượt hạn mức tín dụng',
  CreditControlChange: 'Thay đổi kiểm soát tín dụng',
  AddCopyFormalBusiness: 'Thêm/sao chép nghiệp vụ chính thức',
  OperationSupervisor: 'Giám sát vận hành',
  SalesSupervisor: 'Giám sát bán hàng',
  CreditControlSupervisor: 'Giám sát tín dụng',
  BusinessCustomerService: 'Dịch vụ khách hàng nghiệp vụ',
  MBLTabPrint: 'In thẻ MBL',
  MBLSplitMergePrint: 'In MBL tách đơn/ghép đơn',
  HBLOriginalPrint: 'In bản chính HBL',
  HBLSplitMergeOriginalPrint: 'In bản chính HBL tách đơn/ghép đơn',
  HBLTelexPrint: 'In điện phóng HBL',
  HBLSplitMergeTelexPrint: 'In điện phóng HBL tách đơn/ghép đơn',
  BookingTabPrint: 'In thẻ đặt chỗ',
  BasicTab: 'Thẻ cơ bản',
  MAWBTab: 'Thẻ MAWB',
  HAWBTab: 'Thẻ HAWB',
  BookingEDI: 'EDI đặt chỗ',
  BillOfLadingEDI: 'EDI vận đơn',
  ReturnOrder: 'Hoàn đơn',
  AbnormalStatus: 'Trạng thái bất thường',
  User: 'Người dùng',
  IPAddress: 'Địa chỉ IP',
  PleaseEnterTheIPAddress: 'Vui lòng nhập địa chỉ IP.',
  IndicatesUnrestricted: 'Biểu thị không bị hạn chế',
  IPAddressCannotBeEmpty: 'Địa chỉ IP không được để trống',
  PleaseSelectAUser: 'Vui lòng chọn người dùng',
  ThisAlreadyAddedAnWhitelist: 'Người dùng này đã được thêm vào danh sách trắng IP',
  ExistingSameIPAddress: 'Đã tồn tại địa chỉ IP giống nhau',
  PleaseSelectData: 'Vui lòng chọn dữ liệu',
  BusinessType: 'Loại hình nghiệp vụ',
  BillOfLadingType: 'Loại vận đơn',
  DesignatedShippingLine: 'Hãng tàu chỉ định',
  Expression: 'Biểu thức',
  Example: 'Ví dụ',
  LetterSuffix: 'Hậu tố chữ cái',
  LetterexcludingIAndO: 'Hậu tố chữ cái (không bao gồm I và O)',
  NumberSuffix: 'Hậu tố số',
  MasterBillExtension: 'Số vận đơn chính tiếp nối',
  SuffixSeparator: 'Dấu phân cách hậu tố',
  Constant: 'Hằng số',
  AddRule: 'Thêm quy tắc',
  PleaseEnterRuleName: 'Vui lòng nhập tên quy tắc',
  Reset: 'Đặt lại',
  ServiceCodeMaintenance: 'Bảo trì mã dịch vụ',
  BusinessTypelob: 'Loại hình nghiệp vụ (lob)',
  CargoPickupType: 'Loại hình nhận hàng',
  BranchCodeoffice: 'Mã chi nhánh (office)',
  Salesperson: 'Nhân viên nghiệp vụ',
  NetCodenetCode: 'Mã quản lý mạng (netCode)',
  SalesDepartment: 'Bộ phận bán hàng',
  OperationsDepartment: 'Bộ phận vận hành',
  OverseasWarehouseCodeFBAFC: 'Mã kho nước ngoài (FBA FC)',
  PortCodeport: 'Mã cảng (port)',
  DeliveryPlaceCodeport: 'Mã địa điểm giao hàng (port)',
  PolCode: 'Mã cảng xếp hàng (POL)',
  DeparturePortCode: 'Mã cảng xếp hàng',
  DestinationPortCode: 'Mã cảng đích',
  DeparturePortExchangeCode: 'Mã trao đổi cảng khởi hành',
  DestinationPortExchangeCode: 'Mã trao đổi cảng đích',
  ServiceCode: 'Mã dịch vụ',
  OverseasAgentCode: 'Mã đại lý nước ngoài',
  JobNumberjobNo: 'Số phiếu công việc (jobNo)',
  ReceivableOrPayable: 'Phải trả (RP)',
  Jobyear: 'job (năm)',
  Yearyear: 'Năm (year)',
  Length: 'Độ dài',
  Jobmonth: 'job (tháng)',
  Monthmonth: 'Tháng (month)',
  Dateday: 'Ngày (day)',
  JobSequenceNumberjobSequence: 'Số thứ tự job (jobSequence)',
  RandomLetters: 'Chữ ngẫu nhiên',
  SequenceNumbersequence: 'Số thứ tự (sequence)',
  CustomBusinessTypecustomJobType: 'Loại nghiệp vụ tùy chỉnh (customJobType)',
  SequenceNumberSettings: 'Cài đặt số thứ tự',
  NeverResetN: 'Không bao giờ đặt lại (N)',
  ResetByYearY: 'Đặt lại hàng năm (Y)',
  ResetByMonthM: 'Đặt lại hàng tháng (M)',
  ResetByDayD: 'Đặt lại hàng ngày (D)',
  BusinessDate: 'Ngày nghiệp vụ',
  DepartureDate: 'Ngày khởi hành',
  ShippingDate: 'Ngày gửi hàng',
  ArrivalDate: 'Ngày đến cảng',
  BranchSequenceNumberIndependent: 'Số thứ tự chi nhánh độc lập',
  CustomJobTypeSequenceNumberIndependent: 'Số thứ tự loại nghiệp vụ tùy chỉnh độc lập',
  PaymentDirectionSerialNo: 'Số sê-ri hướng thu chi độc lập',
  DomesticBill: 'Hóa đơn nội địa',
  DomesticBillNo: 'Số hóa đơn nội địa',
  ReceivableAndPayableio: 'Phải thu phải trả (io)',
  BranchConfigurationIndependent: 'Cấu hình chi nhánh độc lập có hiệu lực',
  JoiningDeclarationNumberRule: 'Quy tắc số đơn ghép',
  TakeBillDateOnYearMonthDay: 'Ngày nhận hóa đơn',
  TakeDocumentDateOnYearMonthDay: 'Ngày nhận đơn hàng',
  TakeActualPayDateOnYearMonthDay: 'Ngày nhận tiền thực tế',
  UseBillDateOnYearMonthDay: 'Sử dụng ngày thanh toán sao kê làm điều khiển lưu lượng năm, tháng, ngày.',
  UseDocumentDateOnYearMonthDay: 'Sử dụng ngày lập bản sao kê làm điều khiển lưu lượng năm, tháng, ngày.',
  UseActualPayDateOnYearMonthDay: 'Sử dụng thu thanh toán thực tế làm điều khiển lưu lượng năm, tháng, ngày.',
  DomesticStatement: 'Báo cáo trong nước',
  ForeignStatement: 'Báo cáo nước ngoài',
  AddConstant: 'Thêm hằng số',
  PleaseToJobNumberSettings: 'Vui lòng tham khảo cài đặt số phiếu công việc',
  ConstantCannotBeEmpty: 'Hằng số không được để trống',
  ConstantSpecialCharacters$: 'Hằng số không được chứa ký tự đặc biệt $, {, }',
  ConfigurationCannotBeEmpty: 'Cấu hình không được để trống!',
  LengthExceedsAllowableLength: 'Độ dài vượt quá giới hạn cho phép!',
  ConfigurationExpressionCannotBeEmpty: 'Biểu thức cấu hình không được để trống',
  ThereAtLeastOneName: 'Phải có ít nhất một tên quy tắc',
  JoiningMustChooseAtItem: 'Quy tắc số đơn ghép phải chọn ít nhất một mục',
  ChangingInTheSystemModification: 'Thay đổi cấu hình có thể ảnh hưởng đến truy vấn dữ liệu lịch sử trong hệ thống, bạn có muốn lưu thay đổi không?',
  RuleNameAlreadyExists: 'Tên quy tắc đã tồn tại',
  SaveFailed: 'Lưu thất bại',
  AreWantToDeleteRule: 'Bạn có chắc chắn muốn xóa quy tắc này không?',
  Prompt: 'Thông báo',
  BranchBankAccount: 'Tài khoản ngân hàng chi nhánh',
  SetAsDefaultRMBAccount: 'Đặt làm tài khoản RMB mặc định',
  SetAsDefaultUSDAccount: 'Đặt làm tài khoản USD mặc định',
  Currency: 'Loại tiền tệ',
  Bank: 'Ngân hàng mở tài khoản',
  Abbreviation: 'Tên viết tắt',
  AccountNumber: 'Số tài khoản',
  RMBDefaultAccount: 'Tài khoản RMB mặc định',
  USDDefaultAccount: 'Tài khoản mặc định USD',
  BankChineseAddress: 'Địa chỉ ngân hàng bằng tiếng Trung',
  BankEnglishAddress: 'Địa chỉ ngân hàng bằng tiếng Anh',
  TheItCannotBeAccount: 'Loại tiền tệ của tài khoản này không phải RMB, không thể chọn làm tài khoản RMB mặc định.',
  TheItCannotBeAccount2: 'Loại tiền tệ của tài khoản này không phải USD, không thể chọn làm tài khoản USD mặc định.',
  NameDoYouWantSave: ']Tên đã tồn tại chưa?',
  SaveWantToCloseWindow: 'Lưu thành công, có đóng cửa sổ không?',
  CurrencyCannotBeEmpty: 'Loại tiền tệ không được để trống',
  CodeCannotBeEmpty: 'Mã không được để trống',
  EnglishNameCannotBeEmpty: 'Tên tiếng Anh không được để trống',
  AccountNumberCannotBeEmpty: 'Tài khoản không được để trống',
  TaxControlDiskNumberMaintenance: 'Bảo trì số đĩa thuế',
  Number: 'Số hiệu',
  InvoiceCode: 'Mã điểm xuất hóa đơn',
  UsageDepartment: 'Bộ phận sử dụng',
  TheNumberCannotBeRepeated: 'Số hiệu không được trùng lặp!',
  InvoiceCodeCannotBeRepeated: 'Mã điểm xuất hóa đơn không được trùng lặp!',
  OneToMaintainMultipleNumbers: 'Một bộ phận không được phép bảo trì nhiều số đĩa thuế',
  NumberCannotBeEmpty: 'Số hiệu không được để trống!',
  InvoiceCodeCannotBeEmpty: 'Mã điểm xuất hóa đơn không được để trống!',
  UsageDepartmentCannotBeEmpty: 'Bộ phận sử dụng không được để trống!',
  DepartmentCode: 'Mã bộ phận',
  JobNumberEncodingField: 'Trường mã số công việc',
  IsItASettlementCompany: 'Có phải là công ty thanh toán không?',
  AddDepartment: 'Thêm bộ phận',
  TheOfTheDepartmentEmpty: 'Tên tiếng Trung hoặc tiếng Anh của bộ phận không được để trống',
  EnabledSuccessfully: 'Kích hoạt thành công!',
  DisabledSuccessfully: 'Vô hiệu hóa thành công!',
  SaveSuccessfully: 'Lưu thành công!',
  CompanyCode: 'Mã công ty',
  BranchChineseName: 'Tên tiếng Trung của chi nhánh',
  ChineseAddress: 'Địa chỉ tiếng Trung',
  BranchEnglishName: 'Tên tiếng Anh của chi nhánh',
  City: 'Thành phố',
  PostalCode: 'Mã bưu điện',
  Fax: 'Fax',
  Phone: 'Điện thoại',
  LocalCurrency: 'Loại tiền tệ địa phương',
  DefaultAirport: 'Cảng không mặc định',
  DefaultSeaport: 'Cảng biển mặc định',
  SeaBillOfLadingAddress: 'Địa chỉ vận đơn đường biển',
  AirBillOfLadingAddress: 'Địa chỉ vận đơn đường hàng không',
  RMBAccount: 'Tài khoản RMB',
  USDAccount: 'Tài khoản USD',
  OverseasBillAddress: 'Địa chỉ hóa đơn nước ngoài',
  DomesticBillAddress: 'Địa chỉ hóa đơn trong nước',
  OverseasEDICode: 'Mã EDI nước ngoài',
  MarkupTaxRate: 'Thuế suất cộng thêm',
  InvoiceTaxRate: 'Thuế suất hóa đơn',
  SettlementEmail: 'Email thanh toán',
  TaxSystemInterfaceAddress: 'Địa chỉ giao diện hệ thống thuế',
  TaxControlPanelNumber: 'Số đĩa kiểm soát thuế',
  InvoiceTitle: 'Tiêu đề hóa đơn',
  InvoiceAddress: 'Địa chỉ hóa đơn',
  TaxpayerIdentificationNumber: 'Mã số thuế',
  ElectronicTicketPlatformCode: 'Mã nền tảng hóa đơn điện tử',
  ElectronicTicketPassword: 'Mật khẩu hóa đơn điện tử',
  ElectronicTaxpayerIdentificationNumber: 'Mã số thuế hóa đơn điện tử',
  ElectronicTaxpayerAuthorizationCode: 'Mã ủy quyền người nộp thuế hóa đơn điện tử',
  ElectronicTicketServiceRequestAddress: 'Địa chỉ yêu cầu dịch vụ hóa đơn điện tử',
  InvoiceCancellationRequestAddress: 'Địa chỉ yêu cầu hủy hóa đơn',
  RelatedPartners: 'Đối tác liên kết',
  EFreighAMSAccount: 'E-Freight (Tài khoản AMS)',
  EFreighACIAccount: 'E-Freight (Tài khoản ACI)',
  CopyCompany: 'Sao chép công ty',
  AddBranch: 'Thêm chi nhánh',
  CopyBranch: 'Sao chép chi nhánh',
  BankAccount: 'Tài khoản ngân hàng',
  SelectFile: 'Chọn tệp',
  RemoveFile: 'Xóa tệp',
  NewBranchInformation: 'Thông tin chi nhánh mới',
  N1DepartmentsAndPositionBranch: '1. Tất cả quyền phòng ban và vị trí thuộc chi nhánh này trong quản lý quyền',
  N2ParameterConfiguration: '2. Cấu hình tham số',
  N3OrderNumberConfiguration: '3. Cấu hình số đơn',
  Preview: 'Xem trước',
  Apply: 'Áp dụng',
  CompanyCodeCannotBeEmpty2: 'Mã công ty không được để trống.',
  TheOfTheCompanyEmpty: 'Tên tiếng Trung hoặc tiếng Anh của công ty không được để trống.',
  LocalNotAllowedToEmpty: 'Loại tiền địa phương không được để trống.',
  CopyCompanySucceeded: 'Sao chép công ty thành công',
  AreYouSureToDelete: 'Xác nhận xóa?',
  DeletedSuccessfully: 'Xóa thành công.',
  NameCannotBeEmpty: 'Tên không được để trống',
  SubmitSuccessfully: 'Gửi thành công',
  RoleName: 'Tên vai trò',
  PleaseSelect: 'Vui lòng chọn',
  Individual: 'Cá nhân',
  DepartmentGroup: 'Nhóm phòng ban',
  BatchAddRolePermissions: 'Thêm hàng loạt quyền vai trò',
  UpdatePermissionGroup: 'Cập nhật nhóm quyền',
  Removegtgt: 'Loại bỏ &gt;&gt;',
  ltltAdd: '&lt;&lt; Thêm',
  PermissionName: 'Tên quyền',
  PermissionClass: 'Loại quyền',
  PermissionType: 'Kiểu quyền',
  PermissionPoint: 'Điểm quyền',
  Error: 'Báo lỗi',
  AreDeleteTheCurrentlyRoles: 'Xác nhận xóa mục đã chọn',
  PleaseOrMoreRolesDelete: 'Vui lòng chọn một hoặc nhiều vai trò cần xóa!',
  PleaseOneOrMoreRoles: 'Vui lòng chọn một hoặc nhiều vai trò',
  PleaseOneOrMorePermissions: 'Vui lòng chọn một hoặc nhiều quyền',
  BatchAddSuccessfully: 'Thêm hàng loạt thành công',
  PleaseEnterTheRoleName: 'Vui lòng nhập tên vai trò',
  Meaning: 'Ý nghĩa',
  PleaseEnterTheServiceCode: 'Vui lòng nhập mã dịch vụ',
  PleaseTheServiceCodeMeaning: 'Vui lòng nhập ý nghĩa mã dịch vụ',
  Defaulted: 'Đã mặc định',
  SetAsDefault: 'Đặt làm mặc định',
  SuccessSetting: 'Thiết lập thành công',
  AreToDeleteThisCode: 'Bạn có chắc chắn muốn xóa mã dịch vụ này không?',
  SelectCustomer: 'Chọn khách hàng',
  PleaseCodeEnglishNameName: 'Vui lòng nhập tên viết tắt, mã, tên tiếng Anh, tên tiếng Trung',
  PleaseSelectACustomer: 'Vui lòng chọn khách hàng.',
  DataCargoTrackingPurchaseEffect: 'Dịch vụ đẩy dữ liệu bao gồm: Kế hoạch tàu cảng, dữ liệu container hàng hóa khu cảng, theo dõi hàng hóa hãng tàu. Cấu hình trang này sẽ có hiệu lực sau khi mua dịch vụ đẩy dữ liệu',
  PushFCLLCLType: 'Loại đẩy nguyên container (FCL)',
  PleaseSelectFCLLCLType: 'Vui lòng chọn loại nguyên container (FCL)',
  DoServicesNeedToVoyage: 'Dịch vụ đẩy dữ liệu kế hoạch tàu cảng có cần cập nhật tên tàu, chuyến không?',
  IsTrackingLimitedToDeparture: 'Theo dõi hàng hóa hãng tàu có giới hạn cảng xếp không?',
  EnterpriseType: 'Loại hình doanh nghiệp',
  SelectServiceEnabledSelectEffect: 'Chọn "Tất cả" để thiết lập mở dịch vụ đẩy cho mọi khách hàng; chọn "Danh sách trắng" để thiết lập khách hàng được mở dịch vụ đẩy; chọn "Danh sách đen" để thiết lập khách hàng tắt dịch vụ đẩy. Chỉ thiết lập lần lưu cuối cùng có hiệu lực.',
  WhiteList: 'Danh sách trắng',
  BlackList: 'Danh sách đen',
  DeleteConfiguration: 'Xóa cấu hình',
  PushCondition: 'Điều kiện đẩy',
  DataSettings: 'Thiết lập dữ liệu',
  SynchronizationLogicSettings: 'Thiết lập logic đồng bộ',
  ClearSettings: 'Xóa thiết lập',
  unBerthPlanDateSynETD: 'Đồng bộ thời gian rời bến dự kiến (ETD)',
  estimatedArrivalTimeSynETA: 'Đồng bộ thời gian đến cảng dự kiến (ETA)',
  ClearVoyageAndShipPeriodData: 'Xóa dữ liệu lịch tàu khi sửa/xóa tên tàu, chuyến',
  MorePushConfiguration: 'Cấu hình đẩy thêm...',
  PortPortOfDepartureRange: 'Phạm vi cảng xếp đẩy dữ liệu khu cảng',
  Shanghai: 'Thượng Hải',
  Ningbo: 'Ninh Ba',
  Xiamen: 'Hạ Môn',
  Shenzhen: 'Thâm Quyến',
  Qingdao: 'Thanh Đảo',
  Tianjin: 'Thiên Tân',
  Fuzhou: 'Phúc Châu',
  Dalian: 'Đại Liên',
  NanSha: 'Nam Sa Quảng Châu',
  CustomerList: 'Danh sách khách hàng',
  CloseOpen: 'Tắt thiết lập mở dịch vụ dữ liệu',
  DataServiceSetting: 'Thiết lập dịch vụ dữ liệu',
  DataServiceNotUpdateValue: 'Dịch vụ dữ liệu không cập nhật giá trị trường',
  ConditionType: 'Loại điều kiện',
  Consignor: 'Đơn vị ủy thác',
  PleaseSelectConsignor: 'Vui lòng chọn đơn vị ủy thác',
  SubscriptionScope: 'Phạm vi đăng ký',
  NoConfigurationItemsMade: 'Chưa có thiết lập nào.',
  DeletedSuccessfully2: 'Xóa thành công!',
  FCLLCLTypeNotSelected: 'Chưa chọn loại nguyên container (FCL)',
  PleaseSelectWhiteListCustomers: 'Vui lòng chọn khách hàng danh sách trắng',
  PleaseSelectBlackListCustomers: 'Vui lòng chọn khách hàng danh sách đen',
  SavedSuccessfully: 'Lưu thành công!',
  PleaseLeastOneDataDeletion: 'Vui lòng chọn ít nhất một dữ liệu để xóa!',
  PushServiceProviderConfiguration: 'Cấu hình nhà cung cấp dịch vụ đẩy',
  PushServiceName: 'Tên dịch vụ đẩy',
  ServiceProviders: 'Nhà cung cấp dịch vụ',
  ShanghaiPort: 'Cảng Thượng Hải',
  ShippingCompanyCargoTracking: 'Theo dõi hàng hóa hãng tàu',
  Seabourne: 'Hải Bột',
  FreighTower: 'Phi Đà',
  AirCargoTracking: 'Theo dõi hàng không',
  MaritimeDataPush: 'Đẩy dữ liệu vận tải biển',
  AirFreightDataPush: 'Đẩy dữ liệu vận tải hàng không',
  YundangNet: 'Vân Đương Võng',
  SeaButler: 'Hải Quản Gia',
  NingboPort: 'Cảng Ninh Ba',
  XiamenPort: 'Cảng Hạ Môn',
  QingdaoPort: 'Cảng Thanh Đảo',
  FuzhouPort: 'Cảng Phúc Châu',
  PortShipSchedule: 'Kế hoạch tàu cảng',
  ShenzhenPort: 'Cảng Thâm Quyến',
  DalianPort: 'Cảng Đại Liên',
  TianjinPort: 'Cảng Thiên Tân',
  DataPushCustomerList: 'Danh sách khách hàng đẩy dữ liệu',
  CustomerWhitelist: 'Danh sách trắng khách hàng:',
  PushContent: 'Thiết lập nội dung đẩy vận tải biển',
  AirPushContent: 'Thiết lập nội dung đẩy vận tải hàng không',
  PortContainerData: 'Dữ liệu container cảng',
  NoCustomerSelected: 'Chưa chọn khách hàng.',
  UpdateSuccessful: 'Cập nhật thành công',
  Seaport: 'Cảng biển,',
  Airport: 'Cảng hàng không,',
  ChargeItem: 'Hạng mục thu phí,',
  Route: 'Tuyến đường,',
  Network: 'Mạng lưới,',
  Currency2: 'Loại tiền tệ,',
  ContainerType: 'Loại container,',
  Packaging: 'Đóng gói,',
  BillOfLadingType2: 'Loại vận đơn,',
  CargoType: 'Loại hàng hóa,',
  TradeTerms: 'Điều khoản thương mại,',
  TransportTerms: 'Điều khoản vận chuyển,',
  TradeMode: 'Phương thức thương mại,',
  AirFreightServiceItems: 'Hạng mục dịch vụ cước hàng không,',
  RelatedPort: 'Cảng liên quan,',
  AirCargoBillMiscellaneous: 'Phụ phí vận đơn hàng không,',
  CustomerType: 'Loại khách hàng,',
  BillOfLadingMethod: 'Phương thức vận đơn,',
  CustomBusinessType: 'Loại nghiệp vụ tùy chỉnh,',
  CirculatingDocumentType: 'Loại tài liệu lưu chuyển',
  Initialize: 'Khởi tạo',
  Success: 'Thành công',
  Failure: 'Thất bại',
  AddPort: 'Thêm cảng',
  PleaseSelectPort: 'Vui lòng chọn cảng',
  Operator: 'Nhân viên thao tác',
  PleaseSelectPort2: 'Vui lòng chọn cảng!',
  PleaseSelectOperator: 'Vui lòng chọn một người dùng liên quan.',
  TheAlreadyMaintainedThisInformation: 'Người dùng này đã được cấu hình liên kết',
  PleaseNameEmailEtcQuery: 'Nhập tên tiếng Trung, tên tiếng Anh, email để tìm kiếm mờ...',
  NetManagementCode: 'Mã quản lý mạng',
  AfterBeAbleToContinue: 'Nếu đặt là vô hiệu, người dùng này sẽ không thể đăng nhập hệ thống, bạn có muốn tiếp tục?',
  Valid: 'Có hiệu lực',
  Invalid: 'Vô hiệu',
  PleaseEnterEmail: 'Vui lòng nhập email',
  EditSuccess: 'Chỉnh sửa thành công',
  EmailDuplicate: 'Email bị trùng lặp!',
  UserAllowsInputLettersNumbers: 'Mã người dùng chỉ được phép nhập chữ cái và số.',
  Operator2: 'Nhân viên thao tác:',
  PortCode: 'Mã cảng',
  RelatedUser: 'Người dùng liên quan',
  BusinessMode: 'Mô hình kinh doanh',
  PleaseDataYouWantDelete: 'Vui lòng chọn dữ liệu cần xóa.',
  AreYouWantToDelete2: 'Bạn có chắc chắn muốn xóa hàng loạt {0} mục cấu hình đã chọn không?',
  DeleteSuccess2: 'Xóa thành công.',
  AddRoleUser: 'Thêm người dùng vai trò mới',
  AddUserWithUnassignedRole: 'Thêm người dùng chưa được phân vai trò',
  Query: 'Tìm kiếm',
  DisplaySettings: 'Cài đặt hiển thị',
  ApplicationSettings: 'Cài đặt ứng dụng',
  ReadAndWriteSettings: 'Thiết lập đọc và ghi',
  CanEditable: 'Có thể sửa',
  VisibleToDesignatedPersonnel: 'Hiển thị với nhân sự được chỉ định:',
  FieldPermissionSettings: 'Cài đặt quyền trường dữ liệu',
  SelectDepartment: 'Chọn phòng ban',
  AreYouWantToDelete3: 'Bạn có chắc chắn muốn xóa không?',
  SelectedUsersAlreadyExist: 'Người dùng đã chọn đã tồn tại',
  AddSuccessfully: 'Thêm thành công',
  CopyRole: 'Sao chép vai trò',
  PasteRole: 'Dán vai trò',
  PleaseRoleYouWantCopy: 'Vui lòng chọn vai trò cần sao chép!',
  PleaseYouWantToRole: 'Vui lòng chọn phòng ban để dán vai trò!',
  IPWhitelist: 'Danh sách trắng IP',
  UserWhitelist: 'Danh sách trắng người dùng',
  JobNumber: 'Số đơn hàng',
  NoteMainAndSplit19: 'Giải thích: Số đơn hàng tối đa 21 ký tự, dành 2 ký tự cuối làm ký hiệu đơn chính và tách đơn, do đó, độ dài số đơn cấu hình ở trang này không được vượt quá 19.',
  MainOrderNumber: 'Số đơn chính',
  NoteNumberIsUpLong: 'Giải thích: Số serial vận đơn tối đa 16 ký tự.',
  SubOrderNumber: 'Số đơn phụ',
  NoteIsUpToLong: 'Giải thích: Số đơn phụ tối đa 21 ký tự.',
  WarehouseEntryNumber: 'Số nhập kho',
  BookingNumber: 'Số đặt chỗ',
  NoteYouHaveSelectedLength: 'Giải thích: Số nhập kho tối đa 21 ký tự, nếu đã chọn số đơn hàng, hãy lưu ý độ dài thực tế của nó.',
  OverseasBillNumber: 'Số hóa đơn nước ngoài',
  NoteIsUpToLong2: 'Giải thích: Số hóa đơn nước ngoài tối đa 16 ký tự.',
  PaymentApplicationForm: 'Đơn yêu cầu thanh toán',
  PaymentApprovalForm: 'Đơn phê duyệt thanh toán',
  NoteIsUpToLong3: 'Ghi chú: Số đơn yêu cầu thanh toán tối đa 16 ký tự.',
  NoteIsUpToLong4: 'Mô tả: Số hóa đơn trong nước dài nhất 16 chữ số.',
  BillOfLadingSerialNumber: 'Số vận đơn',
  SeaFreightExport: 'Xuất khẩu đường biển',
  SeaFreightImport: 'Nhập khẩu đường biển',
  AirFreightExport: 'Xuất khẩu đường hàng không',
  AirFreightImport: 'Nhập khẩu đường hàng không',
  FBASeaFreight: 'FBA đường biển',
  FBAAirFreight: 'FBA đường hàng không',
  ReportName: 'Tên báo cáo',
  Report: 'Báo cáo',
  PermissionAddedSuccessfully: 'Thêm quyền thành công',
  PleaseReportLinkedToRole: 'Vui lòng chọn báo cáo liên quan đến vai trò',
  AreToDeleteTheRole: 'Bạn có chắc chắn muốn xóa vai trò đã chọn hiện tại không?',
  PermissionDeletedSuccessfully: 'Xóa quyền thành công',
  QuickSearchAdTheme: 'Tìm kiếm nhanh: Chủ đề quảng cáo',
  AdCode: 'Số quảng cáo',
  AdThemename: 'Chủ đề/Tên quảng cáo',
  AdLocation: 'Vị trí quảng cáo',
  BelongsToPage: 'Trang thuộc về',
  BelongsToModule: 'Module thuộc về',
  BelongingSystem: 'Hệ thống thuộc về',
  PageViews: 'Số lượt xem',
  Clicks: 'Số lượt nhấp',
  ClickRate: 'Tỷ lệ nhấp',
  NumberOfClickUsers: 'Số người dùng nhấp',
  N0FileTypeNotSelected: 'Loại tệp {0} chưa được chọn.',
  NoteCopyFollowingInformation: 'Lưu ý: Bạn đã chọn sao chép 【{0}】 bao gồm các thông tin sau:',
  NXRoles: 'vai trò không?',
  BranchSelection: 'Lựa chọn chi nhánh',
  CheckParentCompanyWithSubsidiary: 'Tích chọn công ty mẹ sẽ tự động tích chọn công ty con',
  CurrentlySelectedProject: 'Mục đã chọn hiện tại:',
  AlertContentConfiguration: 'Cấu hình nội dung cảnh báo',
  AlertTimeConfiguration: 'Cấu hình thời gian cảnh báo',
  SopTimeSetUp: 'Thiết lập thời gian SOP',
  SetPersonalEmail: 'Vui lòng thiết lập thông tin email cá nhân',
  SetPersonalEmailNote1: 'Sau khi thiết lập email cá nhân, email gửi đi thực tế sẽ là email cá nhân của mỗi người dùng, vui lòng đảm bảo mỗi người dùng thiết lập email cá nhân chính xác.',
  SetPersonalEmailNote2: 'Nếu không thiết lập chính xác, hệ thống sẽ lần lượt sử dụng email công ty và email hệ thống làm email gửi đi.',
  SetPersonalEmailStep1: 'Bước 1: Vào Cài đặt và Công cụ, thiết lập email cá nhân.',
  SetPersonalEmailStep2: 'Bước 2: Duy trì mật khẩu/mã ủy quyền email cá nhân, máy chủ gửi, cổng và thông tin chữ ký.',
  SetPersonalEmailStep3: 'Bước 3: Sau khi lưu, có thể sử dụng email cá nhân làm email gửi đi.',
  WhtTax: 'Chế độ thuế WHT',
  WhtTaxTip: 'Áp dụng cho các trường hợp có WHT như Thái Lan. Sau khi kích hoạt, chi phí có thể ghi lại thao tác và thuế WHT, thanh toán bù trừ có thể khấu trừ số thuế WHT.',
  SendDestinationPortProxyDocuments: 'Lịch sử tệp - Gửi tệp đại lý cảng đến',
  MainTicketAttachmentItem: 'Mục đính kèm vé chính',
  SmallTicketAttachmentItem: 'Mục đính kèm vé phụ',
  SelectFileType: 'Chọn loại tệp',
  IncludeSlaveAttachLabel: 'Khi gửi email vé chính, tệp đính kèm phải bao gồm tệp vé phụ',
  AutoGenerationManifestLabel: 'Khi vé chính không có bất kỳ tệp MANIFEST nào, tự động in dựa trên số container',
  FileAttachmentTip: 'Nếu cần xác minh sự tồn tại của tệp đính kèm khi gửi, vui lòng cài đặt trong Cấu hình cơ bản - Cấu hình quy tắc xác minh.',
  FileAttachmentTip2: 'Hệ thống mặc định tự động khớp tệp đính kèm tương ứng theo phương thức vận đơn HBL, có thể tắt trong Cấu hình cơ bản - Quản lý cấu hình.',
  YearMonthEtdTip: 'Cần đồng thời chọn job(năm) và job(tháng), giá trị sẽ được lấy theo năm tháng đã chọn trong [Ngày khởi hành].',
  YearMonthEtaTip: 'Cần đồng thời chọn job(năm) và job(tháng), giá trị sẽ được lấy theo năm tháng đã chọn trong [Ngày đến cảng].',
  RiYearMonthEtaTip: 'Cần đồng thời chọn job(năm) và job(tháng), giá trị sẽ được lấy theo năm tháng đã chọn trong [Ngày đến].',
  NotifySuperiors: 'Quản lý cấp trên của nhân viên vị trí',
  NotifySuperiorsCheckTip: 'Khi chọn [Quản lý cấp trên của nhân viên vị trí], bắt buộc phải chọn ít nhất một [Vị trí chỉ định]!',
  AddOnlyCurrentTemplate: 'Chỉ thêm vào mẫu hiện tại',
  AddOtherSameLobTempalte: 'Thêm vào các mẫu khác cùng loại nghiệp vụ',
  OnlyModifyCurrentTemplate: 'Chỉ sửa đổi mẫu hiện tại ',
  ModifyTemplateContaneNode: 'Sửa đổi tất cả mẫu có chứa nút này',
  AddRanges: 'Phạm vi thêm',
  ModifyRanges: 'Phạm vi sửa đổi',
  ApplicationTemplate: 'Áp dụng mẫu',
  SetNodeLimitTip: 'Khi thiết lập nút, [Mã], [Tên tiếng Trung], [Tên tiếng Anh] của nút SOP cùng loại nghiệp vụ phải nhất quán.',
  SelectSOPTemplateForNode: 'Chọn mẫu SOP áp dụng cho nút',
  ConfirmJoinSelectTemplate: 'Xác nhận thêm vào mẫu SOP đã chọn?',
  AddTemplateSameNode: 'Thêm vào tất cả mẫu có cùng nút',
  ModifyTemplateContinNode: 'Sửa đổi tất cả mẫu có chứa trạng thái nút này',
  HblBlWayAttachLabel: 'Theo phương thức và loại vận đơn của nghiệp vụ, trích xuất tệp HBL tương ứng',
  HblWithoutGenerateAttachLabel: 'Tự động in mẫu HBL khi không có tệp HBL nào',
  ConfirmedPrintHblLabel: 'Tự động in mẫu HBL khi trạng thái HBL là đã xác nhận nhưng chưa phát hành',
  PleaseSetSlaveAttach: 'Vui lòng thiết lập loại tệp cho mục đính kèm hóa đơn trước!',
  QueryFileType: 'Tra cứu loại tệp:',
  HblCfmStateOriginDraftLabel: 'Khi trạng thái HBL chưa phát hành, tệp đính kèm trích mẫu HBL; khi đã phát hành, trích bản HBL',
  BillOfLading: 'Bản vận đơn',
  AssociatedRoutesAndPorts: 'Liên kết tuyến đường và cảng',
  AirlineChineseName: 'Tên tiếng Trung của tuyến đường',
  PortEnglishName: 'Tên tiếng Anh của cảng',
  OperationPosition: 'Vị trí thao tác',
  UserConfigDuplicate: 'Nhân viên {0} đã có dữ liệu cấu hình, không cần cấu hình lại.',
  ConfirmSaveModifiedInfo: 'Xác nhận có lưu thông tin sửa đổi không?',
  PleaseSelectARoute: 'Vui lòng chọn tuyến đường',
  AssociatedPermissions: 'Quyền liên kết',
  OptionalPositionsRoles: 'Vị trí phụ trách có thể chọn giới hạn theo vai trò người dùng',
  ResponsiblePosition: 'Vị trí phụ trách',
  SelectResponsiblePosition: 'Vui lòng chọn vị trí phụ trách!',
  ConfigApplyRemoteBooking: 'Cấu hình áp dụng cho mô-đun đặt chỗ từ xa',
  AssociatedWarehouseSupplier: 'Liên kết nhà cung cấp kho hàng',
  WarehouseNameCustomsBrokeDestinationAgent: 'Vui lòng chọn một mục cấu hình liên kết (tên kho, thông quan, đại lý cảng đích)',
  RelatedCustomsBroker: 'Liên kết đại lý thông quan',
  RelatedDestinationAgent: 'Liên kết đại lý cảng đích',
  AssociatedWarehouseName: 'Liên kết tên kho hàng',
  PortCodeRepeat: 'Cảng {0} đã có cài đặt liên quan, không cần lặp lại.',
  RegionCodeRepeat: 'Tuyến đường {0} đã có cài đặt liên quan, không cần lặp lại.',
  DesignatedCargoControlRange: 'Phạm vi kiểm soát hàng chỉ định:',
  RangeOfSelfPickupControl: 'Phạm vi kiểm soát hàng tự thu:',
  WarningConfiguration: 'Cấu hình cảnh báo:',
  AccountsReceivableSettlementUnits: 'Đơn vị thanh toán tất cả phí phải thu',
  DeletePrompt: 'Xác nhận xóa tài khoản này? Đã thông báo cho YunDang về việc hủy tài khoản chưa?',
  EditUser: 'Chỉnh sửa người dùng',
  NewUser: 'Thêm người dùng mới',
  Password: 'Mật khẩu',
  CustomerName: 'Tên khách hàng',
  AccountMaintenance: 'Bảo trì tài khoản giao diện',
  Unmaintained: 'Bạn chưa cung cấp tài khoản và mật khẩu nên không thể đăng ký dữ liệu cảng, vui lòng liên hệ bộ phận hỗ trợ.',
  PortNotNull: 'Cảng không được để trống',
  CustomerNotNull: 'Tên khách hàng không được để trống',
  AccountNumberNotNull: 'Tài khoản không được để trống',
  PasswordNotNull: 'Mật khẩu không được để trống',
  CustomIdNotNull: 'customId không được để trống',
  PartnerWarehouseCode: 'Mã số nhập kho của đối tác',
  PartnerWarehouseCodeTip: 'Khi đơn vị ủy thác, đại lý hàng hóa chỉ định và đại lý cảng đích trong chứng từ nghiệp vụ đều thiết lập mã nhập kho, có thể thiết lập thứ tự ưu tiên lấy giá trị.',
  MailServer: 'Máy chủ email',
  MailServerConfigTip: 'Cần thiết lập và kích hoạt email công ty trong [Dịch vụ cấu hình push] trước.',
  PushConfigServiceCompanyEmail: 'Cần thiết lập và kích hoạt email công ty trong [Dịch vụ cấu hình đẩy] trước',
  PushConfigServicePersonalEmail: 'Vui lòng chọn email cá nhân của một vị trí chỉ định hoặc một người chỉ định, cần cấu hình email cá nhân và kích hoạt trước khi sử dụng',
  SelectSendEmail: 'Chọn email gửi',
  Assigner: 'Người chỉ định',
  ConfigEmailForNode: 'Cấu hình phương thức gửi email cho nút này',
  MultipleTriggers: 'Kích hoạt nhiều lần',
  IsMultipleTriggers: 'Có kích hoạt nhiều lần không',
  AllowTriggeringAgainValueChange: 'Cho phép kích hoạt lại khi giá trị trường thay đổi',
  OnlyEntityCodeSupportTrigger: 'Chỉ các trường kiểu ngày và chuỗi với mã thực thể: Job / AirExportJob / AirlmportJob / IntegratedJob /SeaExportJob / Sealmportjob hỗ trợ kích hoạt nhiều lần, vui lòng xác nhận với bộ phận phát triển trước!',
  TriggerTypeChangePushMsg: 'Thay đổi giá trị loại kích hoạt sẽ đẩy lại tin nhắn',
  CheckBaseLabel: 'Chỉ đẩy theo danh bạ thiết lập trong chứng từ nghiệp vụ',
  PushExternalInterfaces: 'Đẩy giao diện bên ngoài',
  TriggerInternalEvent: 'Kích hoạt sự kiện nội bộ',
  TriggerTypeChangePushInterface: 'Thay đổi giá trị loại kích hoạt sẽ đẩy lại giao diện',
  XhqBillDataUpdate: 'Cập nhật dữ liệu vận đơn Signal Flag',
  msdBillDataUpdate: 'API đẩy dữ liệu hóa đơn MSD',
  MsdApiLog: 'Nhật ký API MSD',
  canPushPreConfiguration: 'Có thể đẩy cấu hình sẵn',
  pushPreConfiguredInformation: 'Đẩy thông tin cấu hình sẵn',
  pushMasterData: 'Đẩy tất cả thông tin dưới vận đơn chính hiện tại làm dữ liệu cấu hình sẵn. Sau khi kiểm tra, vui lòng nhấp "Xác nhận"',
  AgainPushTitleDisplay: 'Tiêu đề email đẩy lại sẽ hiển thị thay đổi giá trị loại kích hoạt. Ví dụ: Tin đặt chỗ [Tên tàu chuyến xuất khẩu] Cũ: SITC → Mới: LECANGS; Cũ: V.088W → Mới: 0XSJXS',
  CheckRuleToAllBranch: 'Quy tắc xác thực áp dụng cho tất cả chi nhánh',
  CustomDescription: 'Mô tả tùy chỉnh',
  OnlyPositiveFeePermission: 'Không có quyền thao tác. Chỉ được thêm chi phí dương.',
  PleaseSelectOpBranch: 'Vui lòng chọn chi nhánh thao tác!',
  OpOfficeChangeUpdateData: 'Đã sửa đổi chi nhánh thao tác, có cập nhật nhân sự vị trí tương ứng không?',
  WarehouseChangeUpdateData: 'Đã sửa đổi chi nhánh thao tác, có cập nhật kho/đại lý hải quan/đại lý cảng đích tương ứng không?',
  ClassifyName: 'Tên phân loại',
  Sort: 'S.xếp',
  ClassifyMsgNameEmpty: 'Tên phân loại bắt buộc',
  ClassifyMsgSortEmpty: 'Sắp xếp bắt buộc',
  ClassifyMsgNameRepeat: 'Tên phân loại không được trùng lặp',
  ClassifyMsgSortRepeat: 'Số sắp xếp không được trùng lặp',
  ConfirmDeletionOfClassifyMsg: 'Xác nhận xóa phân loại tin nhắn này? Các phiên bản Trung-Anh-Nhật tương ứng cũng sẽ bị xóa!',
  ClassifyMsgDeletedTips: 'Phân loại tin nhắn này có thông báo, không thể xóa!',
  MsgTitle: 'Tiêu đề tin nhắn',
  Content: 'Nội dung',
  ConfirmDeletionOfBellMsg: 'Xác nhận xóa thông báo này? Các phiên bản Trung-Anh-Nhật tương ứng cũng sẽ bị xóa!',
  BellMsgTitleEmpty: 'Tiêu đề tin nhắn bắt buộc',
  BellMsgCodeEmpty: 'Mã bắt buộc',
  BellMsgContentEmpty: 'Nội dung bắt buộc',
  BellMsgTitleRepeat: 'Tiêu đề tin nhắn không được trùng lặp',
  BellMsgCodeRepeat: 'Mã code không được trùng lặp',
  BellMsgContentRepeat: 'Nội dung không được trùng lặp',
  Language: 'Ngôn ngữ',
  Link: 'Địa chỉ chuyển hướng',
  LinkTip: 'Route chuyển hướng dùng để chuyển tin nhắn đến giao diện thao tác tương ứng, vui lòng xác nhận với bộ phận phát triển trước khi điền!',
  BellSubscriptionTitle: 'Cài đặt đăng ký tin nhắn',
  BellSubscriptionConf: 'Đăng ký tin nhắn thông báo',
  BellSubscribed: 'Đã đăng ký',
  BellUnSubscribed: 'Chưa đăng ký',
  MessageConfig: 'Cài đặt tin nhắn',
  WoBaoIntelligentAssistant: 'Trợ lý thông minh Wobao',
  WoBaoSubscriptionTip: 'Trợ lý thông minh Wobao sẽ hiển thị thông báo về tin nhắn chưa đọc trong ngày mà bạn đã đăng ký',
  AllMessage: 'Tất cả tin nhắn',
  TodayUnReadMsg: 'Tin nhắn chưa đọc hôm nay',
  ViewHQMapping: 'Xem ánh xạ HQ',
  BranchNotMatchNotOperate: 'Không thuộc dữ liệu chi nhánh này, không thể thao tác',
  UsersAlertNotifyAfterUsingXX: 'Người dùng có thể cấu hình thông báo cảnh báo sau khi đã sử dụng XX%.',
  UsersAlertNotifyBeforeExpireDate: 'Người dùng có thể cấu hình thông báo cảnh báo trước XX ngày đến hạn.',
  UnloadingEortEnName: 'Tên tiếng Anh cảng dỡ hàng',
  OriginPortEnName: 'Tên tiếng Anh cảng xếp hàng',
  MatchingCriteriaSelection: 'Lựa chọn điều kiện khớp',
  PresetValueConfiguration: 'Cấu hình giá trị mặc định',
  MatchingCriteriaSelectionTip: 'Dùng để khớp tương ứng trong chứng từ nghiệp vụ, khi đáp ứng điều kiện khớp sẽ tự động điền giá trị mặc định.',
  PresetValueConfigurationTip: 'Xuất khẩu đường biển tính số ngày trước dựa trên ETD. Tự động bù ngày cuối tuần, khi số ngày là 0 nghĩa là không tự động tính ngày liên quan.',
  PleaseSelectDeparturePort: 'Vui lòng chọn cảng xếp hàng',
  PleaseSelectUnloadingPort: 'Vui lòng chọn cảng dỡ hàng',
  PleaseSelectCarrier: 'Vui lòng chọn người vận chuyển',
  PortRequirementBillRequirements: 'Yêu cầu cảng (yêu cầu vận đơn)',
  PleaseSaveCurrentDataFirst: 'Vui lòng lưu dữ liệu hiện tại trước',
  RelatedInstructionsAttachments: 'Tài liệu đính kèm liên quan',
  PortRequirementsRelatedDocuments: 'Tài liệu liên quan yêu cầu cảng',
  NoRelevantDocumentsAvailable: 'Không có tài liệu liên quan',
  DefaultConfigurationNotes: 'Ghi chú cấu hình mặc định',
  PleaseSelectMatchingItem: 'Vui lòng chọn một mục khớp',
  CalculateDateIncludeETDTheDay: 'Tính toán số lượng trước bao gồm ngày ETD',
  SetLeadTimeBasedOnETDTime: 'Thiết lập số lượng trước dựa trên thời gian ETD',
  PleaseSetPreset: 'Vui lòng thiết lập một mục mặc định',
  WoBaoSubscribed: 'Đã bật',
  WoBaoUnSubscribed: 'Đã tắt',
  CalculateIncludeEtdIsWeekend: 'Tính toán số lượng trước bao gồm ETD là cuối tuần',
  PositionAssociatedRoutePortConfig: 'Cấu hình mặc định liên kết nhân viên vị trí với tuyến đường/cảng',
  PleaseSelectLoadingPort: 'Vui lòng chọn cảng bốc hàng',
  PleaseSelectOriginatingStation: 'Vui lòng chọn trạm xuất phát',
  PleaseSelectDestinationStation: 'Vui lòng chọn trạm đích',
  PositionCannotDuplicated: 'Vị trí không được trùng lặp',
  UserHasRepeatConfigData: 'Người dùng này đã có dữ liệu cấu hình trùng lặp!',
  UserRoleDefaultRepeat: 'Đã có nhân viên khác cấu hình giá trị mặc định vị trí với điều kiện khớp này, bạn có chắc chắn muốn sửa đổi?',
  ChartSource: 'Nguồn biểu đồ',
  EnterChartSource: 'Vui lòng chọn nguồn biểu đồ',
  ToDoNodeRuleSettings: 'Thiết lập quy tắc nút công việc cần làm',
  ServiceScenarioApplication: 'Quy tắc nghiệp vụ cụ thể',
  SettingApplicationScenarios: 'Thiết lập quy tắc nghiệp vụ',
  OperationButtonSettings: 'Thiết lập nút thao tác',
  ButtonName: 'Tên nút',
  MainNotToDoTask: 'Chứng từ chính không tính là nhiệm vụ công việc (trường hợp ghép container)',
  SpecifyRole: 'Chỉ định vai trò',
  CheckPrivilegePersonLabel: 'Có giới hạn vai trò không có quyền loại chỉnh sửa loại tệp không',
  SetExclusionOffices: 'Thiết lập chi nhánh miễn trừ',
  AccountsReceivable: 'Phí phải thu',
  Just: 'Và',
  NotEntityCompany: 'Công ty không có thực thể',
  NotEntityCompanyTip: 'Khi thống kê báo cáo tài chính cụ thể, cần đánh dấu vào nhãn này.',
  Marked: 'Đánh dấu',
  NotSetDefaultValueMultiPosition: 'Khi điều kiện khớp với nhiều nhân viên vị trí, không hiển thị giá trị mặc định, cần chọn thủ công!',
  AvailableOfficeOverMaxLimit: 'Số lượng chi nhánh khả dụng của bạn đã đạt giới hạn. Nếu cần tăng số lượng chi nhánh, vui lòng liên hệ nhân viên bán hàng hoặc dịch vụ khách hàng.',
  AvailableUserOverMaxLimit: 'Số lượng người dùng khả dụng của bạn đã đạt giới hạn. Nếu cần tăng số lượng người dùng, vui lòng liên hệ nhân viên bán hàng hoặc dịch vụ khách hàng.',
  BranchCountExpireLimitUse: 'Kính gửi quý khách, gói mở rộng chi nhánh đã hết hạn.<br>Vui lòng gia hạn để tiếp tục sử dụng, liên hệ nhân viên bán hàng hoặc dịch vụ khách hàng.<br><div style="margin-top: 5px;">Chi nhánh hiện tại sẽ bị hạn chế truy cập, dữ liệu sẽ được lưu giữ. Sau khi gia hạn, có thể sử dụng lại.</div>',
  UserCountExpireLimitUse: 'Kính gửi quý khách, gói mở rộng người dùng đã hết hạn.<br>Vui lòng gia hạn để tiếp tục sử dụng, liên hệ nhân viên bán hàng hoặc dịch vụ khách hàng.<br><div style="margin-top: 5px;">Người dùng hiện tại sẽ bị vô hiệu hóa, dữ liệu sẽ được lưu giữ. Sau khi gia hạn, có thể kích hoạt lại.</div>',
  UserCountExpireLimitAdmin: 'Kính gửi quý khách, gói mở rộng người dùng đã hết hạn.<br>Vui lòng gia hạn để tiếp tục sử dụng, liên hệ nhân viên bán hàng hoặc dịch vụ khách hàng.<br><div style="margin-top: 5px;">Người dùng hiện tại (trừ quản trị hệ thống) sẽ bị vô hiệu hóa, dữ liệu sẽ được lưu giữ. Sau khi gia hạn, có thể kích hoạt lại.</div>',
  OpenConfig: 'Kích hoạt mục cấu hình',
  SendType: 'Chế độ gửi',
  Key: 'Khóa bí mật',
  UserPwd: 'Mật khẩu tài khoản',
  OpenConfigTip: 'Sau khi kích hoạt, mẫu này sẽ gửi theo {0} đã cấu hình',
  NotEmptyTips: 'Trường màu xanh là bắt buộc!',
  MustBeNumericType: '{0} phải là kiểu số',
  MainTicket: 'VC',
  SlaveTicket: 'VP',
  Alias: 'TK',
  SetAlias: 'Thiết lập tên khác',
  AliasOnlyHQ: 'Thiết lập tên khác chỉ áp dụng thống nhất tại HQ',
  HideCategoryAllLanguage: 'Ẩn phân loại này (áp dụng cho tất cả phiên bản ngôn ngữ)',
  FieldDisplayHideForbid: 'Khi phân loại có trường hiển thị trạng thái, không được phép ẩn!',
  SetBlockWidth: 'Đặt chiều rộng khối',
  SettableRange300400: 'Phạm vi có thể đặt: 300-400',
  HQSavePrompt: 'Nhắc nhở lưu HQ',
  BranchSavePrompt: 'Nhắc nhở lưu chi nhánh',
  OnlyDisplayMandatoryRule: 'Chỉ điều chỉnh quy tắc hiển thị và bắt buộc của trường, không ghi đè thứ tự hiển thị trường trang tùy chỉnh của chi nhánh và nhân viên!',
  DisplayMandatorySort: 'Điều chỉnh quy tắc hiển thị và bắt buộc của trường, và đặt lại thứ tự hiển thị trường trang tùy chỉnh của chi nhánh và nhân viên theo quy tắc HQ!',
  AdjustOrderConfig: 'Mục này sẽ điều chỉnh thứ tự giao diện đã cấu hình của tất cả chi nhánh và nhân viên theo thứ tự thiết lập của HQ!',
  OfficeOnlyDisplayMandatoryRule: 'Chỉ điều chỉnh quy tắc hiển thị và bắt buộc của trường, không ghi đè thứ tự hiển thị trường trang tùy chỉnh của nhân viên!',
  OfficeDisplayMandatorySort: 'Điều chỉnh quy tắc hiển thị và bắt buộc của trường, và đặt lại thứ tự hiển thị trường trang tùy chỉnh của nhân viên theo quy tắc chi nhánh!',
  OfficeAdjustOrderConfig: 'Mục này sẽ điều chỉnh thứ tự giao diện đã cấu hình của nhân viên theo thứ tự thiết lập của chi nhánh!',
  ApplyHQSetting: 'Xác nhận áp dụng thiết lập công ty mẹ?',
  ResetCustomSetConfirm: 'Xác nhận đặt lại thiết lập tùy chỉnh của thẻ này? Thao tác không thể hoàn tác, vui lòng xác nhận!',
  HQSettingNotEditAlias: 'Khi áp dụng thiết lập HQ, chi nhánh không thể chỉnh sửa điều chỉnh. Thiết lập tên khác chỉ áp dụng thống nhất tại HQ.',
  NonLoginUser: 'Người dùng không đăng nhập hệ thống',
  ValidUserNotNeedLogin: 'Người dùng không cần đăng nhập hệ thống trong danh sách người dùng hiệu lực',
  NotLoginUserContactAdmin: 'Quản trị hệ thống đã thiết lập bạn là người dùng không cần đăng nhập. Nếu cần sử dụng hệ thống, vui lòng liên hệ quản trị viên điều chỉnh và đăng nhập lại.',
  FinanceExpireLimitUse: 'Kính gửi quý khách, module quản lý tài chính đã hết hạn.<br>Vui lòng gia hạn để tiếp tục sử dụng, liên hệ nhân viên bán hàng hoặc dịch vụ khách hàng.<br><div style="margin-top: 5px;">Module quản lý tài chính sẽ bị hạn chế truy cập, dữ liệu sẽ được lưu giữ. Sau khi gia hạn, có thể sử dụng lại.</div>',
  EdiExpireLimitUse: 'Kính gửi quý khách, giao diện EDI đặt chỗ đã hết hạn.<br>Vui lòng gia hạn để tiếp tục sử dụng, liên hệ nhân viên bán hàng hoặc dịch vụ khách hàng.',
  TaxExpireLimitUse: 'Kính gửi quý khách, dịch vụ thuế của bạn chưa được kích hoạt hoặc đã hết hạn.<br>Vui lòng gia hạn để tiếp tục sử dụng, có thể liên hệ nhân viên bán hàng hoặc bộ phận hỗ trợ khách hàng.',
  EntrustPageTab: 'Tab ủy thác',
  ExportEntrustPageTab: 'Tab ủy thác xuất khẩu',
  ImportEntrustPageTab: 'Tab ủy thác nhập khẩu',
  AttachmentRuleConfig: 'Cấu hình quy tắc tệp đính kèm',
  BusinessOrdersAttachments: 'Khi nghiệp vụ có phân đơn dạng thức, tệp đính kèm chỉ trích xuất phân đơn dạng thức',
  SendPackageProxyFiles: 'Lịch sử tệp - Gửi tệp đại lý bộ đơn',
  BillNotStartNoneFile: 'Khi trạng thái vận đơn HBL chưa bắt đầu hoặc chờ xác nhận, không trích xuất bất kỳ tệp vận đơn nào (bao gồm cả bản mẫu)',
  LockAfterSend: 'Khóa sau khi gửi:',
  SendLockSlaveHblAndVirtualBill: 'Sau khi gửi, khóa tab HBL và phân đơn dạng thức của phiếu nhỏ (bao gồm tách đơn/ghép đơn)',
  SendLockExchangeAgentHblAndVirtualBill: 'Sau khi gửi, khóa tab HBL và phân đơn dạng thức của đại lý đổi đơn tương ứng (bao gồm tách đơn/ghép đơn)',
  AutoPrintManifestAfterAllHblConfirm: 'Chỉ tự động in tệp MAINFEST sau khi tất cả trạng thái vận đơn HBL được xác nhận (bao gồm cả tách đơn HBL)',
  BusinessDataNotUpdate: 'Khi cập nhật dữ liệu nghiệp vụ, không tự động cập nhật nhân viên vị trí',
  AutoPrintRule: 'Quy tắc in tự động',
  EmailAttachRule: 'Quy tắc trích xuất tệp đính kèm email',
  FormalDivisionRule: 'Quy tắc phân đơn dạng thức',
  BusinessIfVirtualBillOnlyAttachment: 'Khi nghiệp vụ có phân đơn dạng thức, tệp đính kèm chỉ trích xuất tệp phân đơn dạng thức',
  SetFileSyncRule: 'Thiết lập quy tắc đồng bộ tệp',
  BusinessModel: 'Mô hình nghiệp vụ:',
  SyncDirection: 'Hướng đồng bộ:',
  SyncCondition: 'Điều kiện đồng bộ',
  SyncFileToApprovedDoc: 'Có thể đồng bộ tệp vào tài liệu đã phê duyệt',
  DeleteFile: 'Xóa tệp:',
  SyncMode: 'Chế độ đồng bộ:',
  CrossDelegation: 'Ủy thác chéo',
  PrincipalOperator: 'Bên ủy thác -> Bên thao tác',
  OperatorClient: 'Bên thao tác -> Bên ủy thác',
  SyncFileDeletion: 'Đồng bộ xóa tệp',
  NotDeleteRelateFile: 'Không xóa tệp của đối phương',
  ManualSync: 'Đồng bộ thủ công',
  AutoSync: 'Đồng bộ tự động',
  ExportToImport: 'Xuất khẩu chuyển nhập khẩu',
  ExporterImporter: 'Bên xuất khẩu -> Bên nhập khẩu',
  ImporterExporter: 'Bên nhập khẩu -> Bên xuất khẩu',
  BbSendDestinationPortAgent: 'Ủy thác gửi tệp đại lý cảng đích ghép hàng',
  ChargeSyncAuditPass: 'Đồng bộ hóa chi phí - phê duyệt',
  ChargeSyncAuditNotPass: 'Chi phí không được đồng bộ hóa',
  ChargeSyncRecallApplyCharge: 'Chi phí - rút đơn xin chi phí',
  SendEmailByPositionPersonnel: 'Thư sẽ được chuyển tới người thiết lập vị trí của người gửi',
  AttachmentItems: 'Mục tệp đính kèm',
  PleaseSetAttach: 'Vui lòng thiết lập loại tệp mục đính kèm trước!',
  SendLockHblAndVirtualBill: 'Sau khi gửi, khóa tab HBL và phân đơn dạng thức của nghiệp vụ (bao gồm tách đơn/ghép đơn)',
  AirOperationTAB: 'Tab thao tác vận chuyển hàng không',
  CurrentPageNewFieldTip: 'Tab hiện tại có trường mới, vui lòng nhấn chỉnh sửa để thêm trường.',
  SystemAddedItem: 'Mục trường mới hệ thống',
  DragTheBlockUse: 'Vui lòng kéo trường vào khối phân loại tương ứng để sử dụng',
  CustomTemplateMustSelect: 'Tên mẫu tùy chỉnh phải chọn một thông tin',
  VirtualBillHBLNO: 'Phân đơn dạng thức HB/L NO',
  TemplateRemarks: 'Ghi chú mẫu',
  AutomPrintDefaultFileType: 'Loại tệp mặc định in tự động',
  PopupMode: 'Chế độ popup',
  DisplayWhenThereIsValidation: 'Chỉ hiển thị popup thông tin xác thực khi có thông báo lỗi',
  TheBeAppliedToOffices: 'Chế độ popup sẽ áp dụng cho tất cả chi nhánh',
  VerificationNodeCannotBeEmpty: '【Nút xác thực】không được để trống',
  VerificationModeCannotBeEmpty: '【Chế độ xác thực】không được để trống',
  CustomerOfLadingOptionIssue: 'Khách tự xuất đơn (tích chọn khách tự xuất đơn trên vận đơn)',
  WhenLadingHasBeenDocuments: 'Khi có tài liệu tự xuất đơn của khách hàng và vận đơn đã được xác nhận hoặc đã ký phát, trích xuất tự xuất đơn của khách hàng',
  WhenIsNeitherConfirmedExtracted: 'Khi có tài liệu tự xuất đơn của khách hàng nhưng vận đơn chưa được xác nhận hoặc ký phát, không trích xuất tự xuất đơn của khách hàng',
  WhenOfLadingHasSample: 'Khi không có tài liệu tự xuất đơn của khách hàng và vận đơn đã xác nhận nhưng chưa ký phát, tự động in mẫu',
  ApplicationModule: 'Mô-đun ứng dụng',
  UICustomisation: 'Tùy chỉnh giao diện người dùng (UI)',
  SOPPanel: 'Bảng điều khiển SOP',
  FileHistoryTab: 'Tab lịch sử tài liệu',
  ViewOpInstruction: 'Xem chỉ thị thao tác',
  SetOpInstruction: 'Thiết lập chỉ thị thao tác',
  HeadquartersSetupForCommandApplications: 'Cài đặt ứng dụng chỉ thị tại trụ sở chính',
  SetCommandParameters: 'Thiết lập tham số chỉ thị',
  DisplayRuleSettings: 'Cài đặt quy tắc hiển thị',
  PleaseCommandForAScenario: 'Vui lòng thiết lập một chỉ thị thao tác.',
  CommandParameters: 'Tham số chỉ thị',
  SceneRules: 'Quy tắc tình huống',
  SceneParameters: 'Tham số tình huống',
  CommandApplication: 'Ứng dụng chỉ thị',
  TheAsTheOceanConfiguration: 'Tên gọi thay thế của trường kiểm tra trước đặt chỗ giống với thiết lập đặt chỗ vận chuyển bằng đường biển, không hỗ trợ thiết lập riêng biệt!',
  TheAsThoseForConfiguration: 'Các tên gọi thay thế cho trường ủy thác đặt chỗ vận chuyển biển giống với cài đặt đặt chỗ vận chuyển biển, không hỗ trợ cấu hình độc lập!',
  TheAsTheAirConfiguration: 'Trường tên gọi thay thế cho việc đặt chỗ vận chuyển hàng không giống với cài đặt đặt chỗ vận chuyển hàng không, không hỗ trợ thiết lập độc lập!',
  TheThoseInTheConfiguration: 'Các tên gọi thay thế cho trường ủy thác đặt chỗ đường sắt giống với thiết lập vận hành đường sắt, không hỗ trợ cài đặt độc lập!',
  TheOrderInTheConfiguration: 'Bí danh trường kiểm tra trước đơn hàng được căn chỉnh theo cài đặt đặt chỗ vận chuyển hàng không và không hỗ trợ cấu hình độc lập！',
  TriggerNodeStatesupConfigured: 'Kích hoạt quay lại trạng thái của các nút khác (tối đa 5 cấu hình)',
  RollbackBeSetOnlyStartedAbnormal: 'Bạn có thể thiết lập việc quay lại trạng thái của các nút khác chỉ khi [Loại trạng thái] là [Chưa bắt đầu]/[Lỗi]',
  PleaseNodeThatNeedsTriggered: 'Vui lòng thiết lập nút quay lại cần được kích hoạt',
  TheNodeCannotBeEmpty: 'Bộ phận không được để trống',
  TheStatusCannotBeEmpty: 'Trạng thái nút không được để trống',
  AllowStatusToTriggerRollback: 'Cho phép trạng thái nút kích hoạt quá trình quay lui',
  SOPRestrictionsForBusinessDocuments: 'Giới hạn khớp mẫu SOP cho chứng từ nghiệp vụ',
  OnlyForTheBranchTemplate: 'Chỉ các thao tác ứng dụng được thiết lập cho chi nhánh và mẫu HQ',
  OnlyOperationDepartmentAndTemplate: 'Chỉ bộ phận vận hành ứng dụng được thiết lập và mẫu HQ',
  TabSettings: 'Cài đặt Tab',
  StandardFeesTab: 'Thẻ phí tiêu chuẩn',
  HideStandardFeeTab: 'Ẩn tab phí tiêu chuẩn',
  DisplayAsASeparateTab: 'Hiển thị dưới dạng thẻ riêng biệt',
  DropdownBoxValueDisplay: 'Hiển thị giá trị hộp thả xuống:',
  DisplayRecentlyUsed50Values: 'Hiển thị 50 giá trị dữ liệu gần đây nhất được sử dụng',
  DisplayOrderLogic: 'Logic thứ tự hiển thị:',
  TheFirstValueTheSequentially: 'Giá trị được lưu lần cuối cùng sẽ được hiển thị đầu tiên, giá trị trước đó được lưu sẽ hiển thị thứ hai, và cứ thế theo thứ tự.',
  InstructionPermissions: 'Quyền chỉ thị',
  AllPositions2: 'Tất cả các vị trí',
  PleaseAPositionOrPersonnel: 'Vui lòng chọn vị trí hoặc nhân sự',
  SalesModule: 'Module bán hàng',
  SalesInquiry: 'Hỏi về bán hàng',
  SalesInquiryApplication: 'Ứng dụng tra cứu doanh số',
  SalesTheCustomTabUI: 'Tìm kiếm bán hàng cho phép hiển thị thẻ tùy chỉnh của giao diện này',
  DisplayCargoPackingInformation: 'Hiển thị thông tin hàng hóa đóng gói',
  ControlPropertyConfiguration: 'Cấu hình thuộc tính điều khiển',
  WhenMainTicketDisplayMode: 'Khi chứng từ nghiệp vụ là vé chính, hiển thị chế độ đóng gói vé chính.',
  UpdatePortDataButton: 'Nút cập nhật dữ liệu cảng',
  UIFieldConfiguration: 'Cấu hình trường giao diện người dùng',
  AutomatedExecution: 'Thực thi tự động',
  InvokeAutomatedExecution: 'Gọi thực thi tự động',
  SOPStatusTrigger: 'Kích hoạt trạng thái SOP',
  TriggerBasedOnFieldValue: 'Kích hoạt dựa trên giá trị trường',
  DocumentInfo: 'Thông tin Tài liệu',
  DocumentTemplate: 'Biểu mẫu Tài liệu',
  LocalizedTemplateName: 'Tên Biểu mẫu được Bản địa hóa',
  TemplateId: 'ID biểu mẫu',
  TemplateStatus: 'Trạng thái biểu mẫu',
  TemplateType: 'Loại Biểu mẫu',
  TemplateDescription: 'Mô tả Biểu mẫu',
  LocalizedTemplateDescription: 'Mô tả Biểu mẫu được Bản địa hóa',
  ApplicableCarrier: 'Hãng vận chuyển Áp dụng',
  ApplicableSeaport: 'Cảng Áp dụng',
  PleaseEnterLocalTemplateName: 'Vui lòng nhập tên biểu mẫu cục bộ',
  TemplateEnabledPrompt: '【{0}】 - 【{1}】 tệp chính xác. Sau khi kích hoạt, nó có thể được người dùng sử dụng trong nghiệp vụ.',
  TemplateDisabledPrompt: '【{0}】 - 【{1}】 sau khi vô hiệu hóa sẽ không thể được người dùng tìm kiếm hoặc sử dụng trong nghiệp vụ.',
  TemplateDeletedPrompt: 'Vui lòng xác nhận xem 【{0}】 - 【{1}】 đã bị xóa chưa.',
  TriggeredToSpecificBusinessRules: 'Kích hoạt theo các quy tắc kinh doanh cụ thể',
  InvoiceInquiryTab: 'Tab tra cứu hóa đơn',
  SetFieldValueSynchronization: 'Cài đặt đồng bộ giá trị trường',
  SourceTab: 'Thẻ nguồn',
  SourceField: 'Trường nguồn',
  WriteTab: 'Thẻ ghi',
  WriteField: 'Ghi vào trường',
  SyncOnlyAtCreation: 'Chỉ đồng bộ khi tạo',
  SynchronizedReceiptWithMainTicket: 'Phiếu nhỏ đồng bộ với vé chính',
  AreWantToDeleteData: 'Bạn có chắc chắn muốn xóa dữ liệu đã chọn không?',
  TheFieldCannotBeEmpty: 'Trường 【{0}】 không được để trống.',
  ConfirmFieldValueSynchronizationConfiguration: 'Xác nhận cấu hình đồng bộ giá trị trường?',
  ShippingInformationNonMainInvoice: 'Thông tin đóng gói - Phiếu hóa đơn chính',
  PleaseSelectFillModeAndForm: 'Vui lòng chọn chế độ điền và biểu mẫu!',
  FillFormCannotBeEmpty: 'Biểu mẫu điền không thể trống!',
  BatchModificationPrompt: 'Thông báo sửa đổi hàng loạt',
  ConfirmBatchModification: 'Xác nhận sửa đổi hàng loạt? Thao tác này sẽ sửa đổi hàng loạt tất cả các nhiệm vụ đã chọn.',
  BatchModificationConfirm: 'Xác nhận sửa đổi hàng loạt',
  TemplateApplicationSettings: 'Cài đặt ứng dụng mẫu',
  MatchingSettings: 'Cài đặt ghép nối',
  ManualSOPTemplatesIsAllowed: 'Không được phép thay thế mẫu SOP thủ công.',
  DoTemplateIsAutomaticallyTemplate: 'Không hiển thị thông báo khi mẫu được khớp tự động với mẫu mới.',
  ContainerMaxNumTip: 'Số lượng hộp không được vượt quá [{0}] cái. Nếu có nhu cầu vượt quá, vui lòng liên hệ với dịch vụ khách hàng để điều chỉnh ngưỡng tham số [ContainerMaxNum].',
  BatchOperationSettings: 'Cài đặt thao tác hàng loạt',
  BatchOperationsSupported: 'Chức năng thao tác hàng loạt',
  BulkOperationPrompt: 'Thông báo thao tác hàng loạt',
  PleaseSelectRailwayExportServices: 'Vui lòng chọn dịch vụ xuất khẩu đường sắt',
  PleaseSelectRailwayImportBusiness: 'Vui lòng chọn nghiệp vụ nhập khẩu đường sắt',
  BatchAllowedPleaseSelectRecord: 'Không được phép thao tác hàng loạt. Vui lòng chọn một bản ghi duy nhất.',
  AreWantToPerformOperation: 'Bạn có chắc chắn muốn thực hiện thao tác hàng loạt không?',
  NonNotSupportCrossTenants: 'Các công ty không thuộc tập đoàn không hỗ trợ ủy quyền chéo giữa các thuê bao.',
  NoBusinessCanBeEntrusted: 'Không có công việc nào có thể ủy thác',
  PleaseSelect0: 'Vui lòng chọn {0}',
  ShippingInformationMasterBill: 'Thông tin đóng gói - Phiếu vận đơn chính',
  HideDefaultButton: 'Ẩn nút mặc định',
  AdditionalReceivables: 'Phát sinh phải thu thêm',
  AdditionalPayable: 'Phát sinh phải trả'
}
